import React, { Component } from "react";
// import './test.css';
import "font-awesome/css/font-awesome.min.css";
import * as message from "../MessageConstant";
class SvgColorOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fromOverview:
        this.props.fromOverview !== undefined ? this.props.fromOverview : false,
      isAsp: this.props.isAsp !== undefined ? this.props.isAsp : false,
      hostOnly: this.props.hostOnly !== undefined ? this.props.hostOnly : false,
      entityType:
        this.props.entityType !== undefined
          ? this.props.entityType
          : this.props.isAsp !== undefined && this.props.isAsp === true
          ? "asp"
          : "vm",
    };
  }

  render() {
    const {
      data,
      valStatus,
      forValidation,
      valData,
      showCostPerfMarker,
      type = "",
    } = this.props;
    let forVal =
      forValidation !== undefined && forValidation !== null
        ? forValidation
        : false;
    let validationIndicator = forVal === false ? 0 : 1;
    let bvmStatus = valStatus;

    let colorStatusUtils = ["poor", "fair", "good"];
    let colorStatusHealth = ["normal", "borderline", "abnormal"];

    if (
      forVal === true &&
      (valStatus === "VALIDATED" ||
        valStatus === "CUSTOM-SIZED" ||
        valStatus === "OPTIMALLY SIZED" ||
        valStatus === "OPTIMIZING")
    ) {
      validationIndicator = 1;
      bvmStatus = "VALIDATED";
    } else if (forVal === true && valStatus === "VALIDATING") {
      validationIndicator = 2;
    }
    let isGreyedOut = data[0].icon === "memory" && this.state.hostOnly === true;

    console.log(
      "this.state.hostOnly",
      this.state.hostOnly,
      data[0].icon
    );

    
    let costPerfMarker = (
      <div class="marker-box">
        <div class="cost-marker">Cost</div>
        <div class="dotted-line"></div>
        <div class="perf-marker">Perf</div>
      </div>
    );
    let ico = <div />;
    let rightArrow = <div class="arrow-right"></div>;
    let resizeIco = <div />;
    let lineSeparator = <div class="separator"></div>;
    let resizeStatusIcon = <div />;
    let costVal = data[0].costColor ? data[0].costColor.toLowerCase() : "";
    let perfVal = data[0].healthColor ? data[0].healthColor.toLowerCase() : "";
    let valUtil = "y";
    let valHealth = "y";
    let cpuCostIco =
      "M61.52,32.7H68V34H50.79V20.38a3.171,3.171,0,0,0-3.17-3.17H20.38a3.171,3.171,0,0,0-3.17,3.17V34H0V32.7H6.48V29H0V26.4H6.48V22.7H0V20.11H6.48V16.4H0V13.81H6.48V11.67a5.1982,5.1982,0,0,1,5.19-5.19h2.08V0h2.6V6.48h3.7V0h2.59V6.48h3.71V0h2.59V6.48h3.71V0h2.59V6.48h3.71V0h2.59V6.48h3.7V0h2.6V6.48h3.7V0h2.6V6.48h2.19a5.1982,5.1982,0,0,1,5.19,5.19v2.14H68V16.4H61.52v3.71H68V22.7H61.52v3.7H68V29H61.52Z";
    let cpuPerfIco =
      "M61.52,51.6H68v2.59H61.52v2.14a5.1982,5.1982,0,0,1-5.19,5.19H54.19V68H51.6V61.52H47.89V68H45.3V61.52H41.6V68H39V61.52H35.3V68H32.7V61.52H29V68H26.4V61.52H22.7V68H20.11V61.52H16.4V68H13.81V61.52H11.67a5.1982,5.1982,0,0,1-5.19-5.19V54.19H0V51.6H6.48V47.89H0V45.3H6.48V41.6H0V39H6.48V35.3H0V34H17.21V47.62a3.171,3.171,0,0,0,3.17,3.17H47.62a3.171,3.171,0,0,0,3.17-3.17V34H68v1.3H61.52V39H68v2.6H61.52v3.7H68v2.59H61.52Z";
    if (this.state.entityType === "db") {
      cpuCostIco =
        "M68,32.71V34H56.32V15.89a4.208,4.208,0,0,0-4.21-4.2H15.89a4.2,4.2,0,0,0-4.2,4.2V34H0V32.71H6.49V29H0V26.41H6.49V22.7H0V20.11H6.49V16.4H0V13.81H6.49V11.67a5.1811,5.1811,0,0,1,5.18-5.18h2.08V0h2.6V6.49h3.7V0h2.6V6.49h3.7V0h2.59V6.49h3.71V0h2.59V6.49h3.71V0h2.59V6.49h3.71V0h2.59V6.49h3.7V0h2.6V6.49h2.19a5.1832,5.1832,0,0,1,5.19,5.18v2.14H68V16.4H61.52v3.71H68V22.7H61.52v3.71H68V29H61.52v3.71Z";
      cpuPerfIco =
        "M68,51.6v2.59H61.52v2.14a5.1853,5.1853,0,0,1-5.19,5.19H54.19V68H51.6V61.52H47.9V68H45.3V61.52H41.6V68H39V61.52H35.3V68H32.71V61.52H29V68H26.41V61.52H22.7V68H20.11V61.52H16.4V68H13.81V61.52H11.67a5.1832,5.1832,0,0,1-5.18-5.19V54.19H0V51.6H6.49V47.9H0V45.3H6.49V41.6H0V39H6.49V35.3H0V34H11.69V52.11a4.208,4.208,0,0,0,4.2,4.21H52.11a4.2166,4.2166,0,0,0,4.21-4.21V34H68v1.3H61.52V39H68v2.6H61.52v3.7H68v2.6H61.52v3.7Z";
    }
    var tt = Math.floor(Math.random() * 100 + 1);

    switch (data[0].icon) {
      case "gpu":
        if (validationIndicator === 1) {
          costVal = valData.validationVM.sim_current_cpu_cost.toLowerCase();
          perfVal = valData.validationVM.sim_current_cpu_health.toLowerCase();
          valUtil =
            valData.validationVM.sim_cpu_utils_result === "N/A"
              ? "na"
              : valData.validationVM.sim_cpu_utils_result === "*"
              ? "star"
              : valData.validationVM.sim_cpu_utils_result === null
              ? "skip"
              : valData.validationVM.sim_cpu_utils_result.toLowerCase();
          valHealth =
            valData.validationVM.sim_cpu_health_result === "N/A"
              ? "na"
              : valData.validationVM.sim_cpu_health_result === "*"
              ? "star"
              : valData.validationVM.sim_cpu_health_result === null
              ? "skip"
              : valData.validationVM.sim_cpu_health_result.toLowerCase();
        }
        ico = (
          <div
            className={this.state.fromOverview ? "" : "svgColorIconContainer"}
          >
            <div className="cpu-svg">
              <div id={"gpuCostTT" + tt} className="cost-tooltip-box">
                {costVal === "good" ? "$" : costVal === "fair" ? "$$" : "$$$"}
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 68 68">
                <path
                  id="cpu-cost"
                  className={costVal}
                  d={cpuCostIco}
                  onMouseOver={() => {
                    this.showToolTip("gpuCostTT" + tt);
                  }}
                  onMouseOut={() => {
                    this.hideToolTip("gpuCostTT" + tt);
                  }}
                />
                <path
                  id="cpu-health"
                  className={perfVal}
                  d={cpuPerfIco}
                  onMouseOver={() => {
                    this.showToolTip("cpuPerfTT" + tt);
                  }}
                  onMouseOut={() => {
                    this.hideToolTip("cpuPerfTT" + tt);
                  }}
                />
                {this.state.entityType === "db" ? (
                  <path
                    id="memory"
                    class="grayed-out"
                    d="M52.63,17.03H47.7a1.99,1.99,0,1,1-3.98,0H23.61a1.995,1.995,0,1,1-3.99,0H15.38a1.3507,1.3507,0,0,0-1.35,1.35V43.16a1.3423,1.3423,0,0,0,1.35,1.34h1.75v6.47h1.41V46.04h1.8v4.93h1.81V46.04h1.81v4.93h1.81V46.04h1.8v4.93h1.81V46.04h1.81v4.93H33V46.04h1.81v4.93h1.8V46.04h1.81v4.93h1.81V46.04h1.81v4.93h1.8V46.04h1.81v4.93h1.81V46.04h1.81v4.93h1.6V44.5h1.76a1.34,1.34,0,0,0,1.34-1.34V18.38A1.3487,1.3487,0,0,0,52.63,17.03ZM27.5,40.21a.8237.8237,0,0,1-.82.82H17.99a.8152.8152,0,0,1-.81-.82V24.71a.8066.8066,0,0,1,.81-.81h8.69a.8152.8152,0,0,1,.82.81Zm11.69,0a.8237.8237,0,0,1-.82.82H29.68a.8237.8237,0,0,1-.82-.82V24.71a.8152.8152,0,0,1,.82-.81h8.69a.8152.8152,0,0,1,.82.81Zm11.68,0a.8152.8152,0,0,1-.81.82H41.37a.8237.8237,0,0,1-.82-.82V24.71a.8152.8152,0,0,1,.82-.81h8.69a.8066.8066,0,0,1,.81.81Z"
                  />
                ) : null}

                <text
                  x="34"
                  y="38"
                  fill="black"
                  fontSize="13"
                  fontFamily="Arial, sans-serif"
                  textAnchor="middle"
                >
                  GPU
                </text>
              </svg>
              <div
                id={"cpuPerfTT" + tt}
                className={"pref-tooltip-box pref-" + perfVal}
              ></div>
            </div>
          </div>
        );
        if (this.props.isResize === true) {
          let costResizeIconColor = costVal;
          let perfResizeIconColor = perfVal;

          if (type === "recommendation") {
            const costIndex =
              data[0]?.recommendationsIconColor?.costColor ?? -1;
            const healthIndex =
              data[0]?.recommendationsIconColor?.healthColor ?? -1;

            costResizeIconColor = colorStatusUtils[costIndex] ?? "na";
            perfResizeIconColor = colorStatusHealth[healthIndex] ?? "na";
          }

          resizeIco = (
            <div
              className={this.state.fromOverview ? "" : "svgGreyIconContainer"}
            >
              <div className="info-graphic-empty">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 68 68">
                  <g id="cpuArrowIcon">
                    <path
                      id="cpu-cost"
                      className={costResizeIconColor}
                      d={cpuCostIco}
                    />
                    <path
                      id="cpu-health"
                      className={perfResizeIconColor}
                      d={cpuPerfIco}
                    />
                    <text
                      x="34"
                      y="38"
                      fill="black"
                      fontSize="13"
                      fontFamily="Arial, sans-serif"
                      textAnchor="middle"
                    >
                      GPU
                    </text>
                  </g>
                  <rect className="bondingBox" width="68" height="68" />
                </svg>
              </div>
            </div>
          );
          if (validationIndicator === 1) {
            resizeIco = (
              <div
                className={
                  this.state.fromOverview ? "" : "svgColorIconContainer"
                }
              >
                <div className="cpu-svg">
                  <div id={"cpuCostValTT" + tt} className="cost-tooltip-box">
                    {valData.validationVM.sim_rec_cpu_cost.toLowerCase() ===
                    "good"
                      ? "$"
                      : valData.validationVM.sim_rec_cpu_cost.toLowerCase() ===
                        "fair"
                      ? "$$"
                      : "$$$"}
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 68 68">
                    <path
                      id="cpu-cost"
                      className={valData.validationVM.sim_rec_cpu_cost.toLowerCase()}
                      d="M61.52,32.7H68V34H50.79V20.38a3.171,3.171,0,0,0-3.17-3.17H20.38a3.171,3.171,0,0,0-3.17,3.17V34H0V32.7H6.48V29H0V26.4H6.48V22.7H0V20.11H6.48V16.4H0V13.81H6.48V11.67a5.1982,5.1982,0,0,1,5.19-5.19h2.08V0h2.6V6.48h3.7V0h2.59V6.48h3.71V0h2.59V6.48h3.71V0h2.59V6.48h3.71V0h2.59V6.48h3.7V0h2.6V6.48h3.7V0h2.6V6.48h2.19a5.1982,5.1982,0,0,1,5.19,5.19v2.14H68V16.4H61.52v3.71H68V22.7H61.52v3.7H68V29H61.52Z"
                      onMouseOver={() => {
                        this.showToolTip("cpuCostValTT" + tt);
                      }}
                      onMouseOut={() => {
                        this.hideToolTip("cpuCostValTT" + tt);
                      }}
                    />
                    <path
                      id="cpu-health"
                      className={valData.validationVM.sim_rec_cpu_health.toLowerCase()}
                      d="M61.52,51.6H68v2.59H61.52v2.14a5.1982,5.1982,0,0,1-5.19,5.19H54.19V68H51.6V61.52H47.89V68H45.3V61.52H41.6V68H39V61.52H35.3V68H32.7V61.52H29V68H26.4V61.52H22.7V68H20.11V61.52H16.4V68H13.81V61.52H11.67a5.1982,5.1982,0,0,1-5.19-5.19V54.19H0V51.6H6.48V47.89H0V45.3H6.48V41.6H0V39H6.48V35.3H0V34H17.21V47.62a3.171,3.171,0,0,0,3.17,3.17H47.62a3.171,3.171,0,0,0,3.17-3.17V34H68v1.3H61.52V39H68v2.6H61.52v3.7H68v2.59H61.52Z"
                      onMouseOver={() => {
                        this.showToolTip("cpuPerfValTT" + tt);
                      }}
                      onMouseOut={() => {
                        this.hideToolTip("cpuPerfValTT" + tt);
                      }}
                    />
                  </svg>
                  <div
                    id={"cpuPerfValTT" + tt}
                    className={
                      "pref-tooltip-box pref-" +
                      valData.validationVM.sim_rec_cpu_health.toLowerCase()
                    }
                  ></div>
                </div>
              </div>
            );
            rightArrow = (
              <div class="small-icon-container">
                <div className={"cost-small-icon " + valUtil + "-tick"}></div>
                <div class="arrow-right"></div>
                <div class={"pref-small-icon " + valHealth + "-tick"}></div>
              </div>
            );
          }
        }
        if (this.props.isIcon === true) {
          let curStatus =
            validationIndicator === 2 || data[0].status === null
              ? "pending"
              : data[0].status.toLowerCase();
          resizeStatusIcon = (
            <div className="state-container-resize">
              <div className="state-icon-resize">
                <div
                  className={"state-icon " + curStatus}
                  title={curStatus.toUpperCase()}
                ></div>
              </div>
            </div>
          );
          if (validationIndicator === 1) {
            resizeStatusIcon = (
              <div className="state-container">
                <div class="space-filler"></div>
                <div class="state-name1">Current</div>
                <div class="state-name2">{this.props.valObjective}</div>
              </div>
            );
            rightArrow = (
              <div class="small-icon-container">
                <div className={"cost-small-icon " + valUtil + "-tick"}></div>
                <div class="arrow-right"></div>
                <div class={"pref-small-icon " + valHealth + "-tick"}></div>
              </div>
            );
          }
        }
        break;
      case "gpumemory":
        if (validationIndicator === 1) {
          costVal = valData.validationVM.sim_current_memory_cost.toLowerCase();
          perfVal =
            valData.validationVM.sim_current_memory_health.toLowerCase();
          valUtil =
            valData.validationVM.sim_memory_utils_result === "N/A"
              ? "na"
              : valData.validationVM.sim_memory_utils_result === "*"
              ? "star"
              : valData.validationVM.sim_memory_utils_result === null
              ? "skip"
              : valData.validationVM.sim_memory_utils_result.toLowerCase();
          valHealth =
            valData.validationVM.sim_memory_health_result === "N/A"
              ? "na"
              : valData.validationVM.sim_memory_health_result === "*"
              ? "star"
              : valData.validationVM.sim_memory_health_result === null
              ? "skip"
              : valData.validationVM.sim_memory_health_result.toLowerCase();
        }
        ico = (
          <div
            className={this.state.fromOverview ? "" : "svgColorIconContainer"}
          >
            <div className="memory-svg">
              {isGreyedOut ? null : (
                <div id={"ddCostTT" + tt} className="cost-tooltip-box">
                  {costVal === "good" ? "$" : costVal === "fair" ? "$$" : "$$$"}
                </div>
              )}
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 68">
                <path
                  id="mem-cost"
                  className={isGreyedOut ? "na" : costVal}
                  d="M29.7131,15.38V34h-2.73V15.38a1.6325,1.6325,0,0,0-1.64-1.63H7.9331a1.63,1.63,0,0,0-1.63,1.63V34h-6.3V2.69A2.6908,2.6908,0,0,1,2.6931,0h8.51a3.9882,3.9882,0,0,0,3.99,3.99A3.9946,3.9946,0,0,0,19.1831,0h40.31a3.9882,3.9882,0,0,0,3.99,3.99A3.9946,3.9946,0,0,0,67.4731,0h9.86a2.6908,2.6908,0,0,1,2.69,2.69V34h-6.2V15.38a1.6389,1.6389,0,0,0-1.64-1.63h-17.41a1.6389,1.6389,0,0,0-1.64,1.63V34h-2.73V15.38a1.6325,1.6325,0,0,0-1.64-1.63h-17.41A1.6389,1.6389,0,0,0,29.7131,15.38Z"
                  transform="translate(-0.0031)"
                  onMouseOver={() => {
                    this.showToolTip("ddCostTT" + tt);
                  }}
                  onMouseOut={() => {
                    this.hideToolTip("ddCostTT" + tt);
                  }}
                />
                <path
                  id="mem-health"
                  className={isGreyedOut ? "na" : perfVal}
                  d="M29.7131,46.44a1.641,1.641,0,0,0,1.64,1.64h17.41a1.6346,1.6346,0,0,0,1.64-1.64V34h2.73V46.44a1.641,1.641,0,0,0,1.64,1.64h17.41a1.641,1.641,0,0,0,1.64-1.64V34h6.2V52.34a2.6844,2.6844,0,0,1-2.69,2.69h-3.51V68h-3.22V58.12h-3.62V68h-3.63V58.12h-3.62V68h-3.62V58.12h-3.62V68h-3.63V58.12h-3.62V68h-3.62V58.12h-3.62V68h-3.62V58.12h-3.63V68h-3.62V58.12h-3.62V68h-3.62V58.12h-3.63V68h-3.62V58.12h-3.62V68h-2.82V55.03h-3.51a2.6844,2.6844,0,0,1-2.69-2.69V34h6.3V46.44a1.6325,1.6325,0,0,0,1.63,1.64h17.41a1.6346,1.6346,0,0,0,1.64-1.64V34h2.73Z"
                  transform="translate(-0.0031)"
                  onMouseOver={() => {
                    this.showToolTip("ddPerfTT" + tt);
                  }}
                  onMouseOut={() => {
                    this.hideToolTip("ddPerfTT" + tt);
                  }}
                />
                <text
                  x="43"
                  y="37"
                  fill="black"
                  fontSize="13"
                  fontFamily="Arial, sans-serif"
                  textAnchor="middle"
                  style={{ letterSpacing: "5.5px" }}
                >
                  G P {`  `}U
                </text>
              </svg>
              {isGreyedOut ? null : (
                <div
                  id={"ddPerfTT" + tt}
                  className={"pref-tooltip-box pref-" + perfVal}
                ></div>
              )}
            </div>
          </div>
        );
        if (this.props.isResize === true) {
          let costResizeIconColor = costVal;
          let perfResizeIconColor = perfVal;

          if (type === "recommendation") {
            const costIndex =
              data[0]?.recommendationsIconColor?.costColor ?? -1;
            const healthIndex =
              data[0]?.recommendationsIconColor?.healthColor ?? -1;

            costResizeIconColor = colorStatusUtils[costIndex] ?? "na";
            perfResizeIconColor = colorStatusHealth[healthIndex] ?? "na";
          }

          resizeIco = (
            <div
              className={this.state.fromOverview ? "" : "svgGreyIconContainer"}
            >
              <div className="memory-svg">
                <svg
                  id="memoryIconAnalysis"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 80 68"
                >
                  <path
                    id="mem-cost"
                    className={costResizeIconColor}
                    d="M29.7131,15.38V34h-2.73V15.38a1.6325,1.6325,0,0,0-1.64-1.63H7.9331a1.63,1.63,0,0,0-1.63,1.63V34h-6.3V2.69A2.6908,2.6908,0,0,1,2.6931,0h8.51a3.9882,3.9882,0,0,0,3.99,3.99A3.9946,3.9946,0,0,0,19.1831,0h40.31a3.9882,3.9882,0,0,0,3.99,3.99A3.9946,3.9946,0,0,0,67.4731,0h9.86a2.6908,2.6908,0,0,1,2.69,2.69V34h-6.2V15.38a1.6389,1.6389,0,0,0-1.64-1.63h-17.41a1.6389,1.6389,0,0,0-1.64,1.63V34h-2.73V15.38a1.6325,1.6325,0,0,0-1.64-1.63h-17.41A1.6389,1.6389,0,0,0,29.7131,15.38Z"
                    transform="translate(-0.0031)"
                  />
                  <path
                    id="mem-health"
                    className={perfResizeIconColor}
                    d="M29.7131,46.44a1.641,1.641,0,0,0,1.64,1.64h17.41a1.6346,1.6346,0,0,0,1.64-1.64V34h2.73V46.44a1.641,1.641,0,0,0,1.64,1.64h17.41a1.641,1.641,0,0,0,1.64-1.64V34h6.2V52.34a2.6844,2.6844,0,0,1-2.69,2.69h-3.51V68h-3.22V58.12h-3.62V68h-3.63V58.12h-3.62V68h-3.62V58.12h-3.62V68h-3.63V58.12h-3.62V68h-3.62V58.12h-3.62V68h-3.62V58.12h-3.63V68h-3.62V58.12h-3.62V68h-3.62V58.12h-3.63V68h-3.62V58.12h-3.62V68h-2.82V55.03h-3.51a2.6844,2.6844,0,0,1-2.69-2.69V34h6.3V46.44a1.6325,1.6325,0,0,0,1.63,1.64h17.41a1.6346,1.6346,0,0,0,1.64-1.64V34h2.73Z"
                    transform="translate(-0.0031)"
                  />

                  <text
                    x="43"
                    y="37"
                    fill="black"
                    fontSize="13"
                    fontFamily="Arial, sans-serif"
                    textAnchor="middle"
                    style={{ letterSpacing: "5.5px" }}
                  >
                    G P {`  `}U
                  </text>
                </svg>
              </div>
            </div>
          );
          if (validationIndicator === 1) {
            resizeIco = (
              <div
                className={
                  this.state.fromOverview ? "" : "svgColorIconContainer"
                }
              >
                <div className="memory-svg">
                  <div id={"ddCostTTVal" + tt} className="cost-tooltip-box">
                    {valData.validationVM.sim_rec_memory_cost.toLowerCase() ===
                    "good"
                      ? "$"
                      : valData.validationVM.sim_rec_memory_cost.toLowerCase() ===
                        "fair"
                      ? "$$"
                      : "$$$"}
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 68">
                    <path
                      id="mem-cost"
                      className={valData.validationVM.sim_rec_memory_cost.toLowerCase()}
                      d="M29.7131,15.38V34h-2.73V15.38a1.6325,1.6325,0,0,0-1.64-1.63H7.9331a1.63,1.63,0,0,0-1.63,1.63V34h-6.3V2.69A2.6908,2.6908,0,0,1,2.6931,0h8.51a3.9882,3.9882,0,0,0,3.99,3.99A3.9946,3.9946,0,0,0,19.1831,0h40.31a3.9882,3.9882,0,0,0,3.99,3.99A3.9946,3.9946,0,0,0,67.4731,0h9.86a2.6908,2.6908,0,0,1,2.69,2.69V34h-6.2V15.38a1.6389,1.6389,0,0,0-1.64-1.63h-17.41a1.6389,1.6389,0,0,0-1.64,1.63V34h-2.73V15.38a1.6325,1.6325,0,0,0-1.64-1.63h-17.41A1.6389,1.6389,0,0,0,29.7131,15.38Z"
                      transform="translate(-0.0031)"
                      onMouseOver={() => {
                        this.showToolTip("ddCostTTVal" + tt);
                      }}
                      onMouseOut={() => {
                        this.hideToolTip("ddCostTTVal" + tt);
                      }}
                    />
                    <path
                      id="mem-health"
                      className={valData.validationVM.sim_rec_memory_health.toLowerCase()}
                      d="M29.7131,46.44a1.641,1.641,0,0,0,1.64,1.64h17.41a1.6346,1.6346,0,0,0,1.64-1.64V34h2.73V46.44a1.641,1.641,0,0,0,1.64,1.64h17.41a1.641,1.641,0,0,0,1.64-1.64V34h6.2V52.34a2.6844,2.6844,0,0,1-2.69,2.69h-3.51V68h-3.22V58.12h-3.62V68h-3.63V58.12h-3.62V68h-3.62V58.12h-3.62V68h-3.63V58.12h-3.62V68h-3.62V58.12h-3.62V68h-3.62V58.12h-3.63V68h-3.62V58.12h-3.62V68h-3.62V58.12h-3.63V68h-3.62V58.12h-3.62V68h-2.82V55.03h-3.51a2.6844,2.6844,0,0,1-2.69-2.69V34h6.3V46.44a1.6325,1.6325,0,0,0,1.63,1.64h17.41a1.6346,1.6346,0,0,0,1.64-1.64V34h2.73Z"
                      transform="translate(-0.0031)"
                      onMouseOver={() => {
                        this.showToolTip("ddPerfTTVal" + tt);
                      }}
                      onMouseOut={() => {
                        this.hideToolTip("ddPerfTTVal" + tt);
                      }}
                    />
                  </svg>
                  <div
                    id={"ddPerfTTVal" + tt}
                    className={
                      "pref-tooltip-box pref-" +
                      valData.validationVM.sim_rec_memory_health.toLowerCase()
                    }
                  ></div>
                </div>
              </div>
            );
          }
        }
        if (this.props.isIcon === true) {
          let curStatus =
            validationIndicator === 2 || data[0].status === null
              ? "pending"
              : data[0].status.toLowerCase();
          resizeStatusIcon = (
            <div className="state-container-resize">
              <div className="state-icon-resize">
                <div
                  className={"state-icon " + curStatus}
                  title={curStatus.toUpperCase()}
                ></div>
              </div>
            </div>
          );
          if (validationIndicator === 1) {
            resizeStatusIcon = (
              <div className="mem-state-container">
                <div className="mem-state-name1">Current</div>
                <div className="mem-state-name2">{this.props.valObjective}</div>
              </div>
            );
            rightArrow = (
              <div class="small-icon-container">
                <div className={"cost-small-icon " + valUtil + "-tick"}></div>
                <div class="arrow-right"></div>
                <div class={"pref-small-icon " + valHealth + "-tick"}></div>
              </div>
            );
          }
        }
        break;
      case "cpu":
        if (validationIndicator === 1) {
          costVal = valData.validationVM.sim_current_cpu_cost.toLowerCase();
          perfVal = valData.validationVM.sim_current_cpu_health.toLowerCase();
          valUtil =
            valData.validationVM.sim_cpu_utils_result === "N/A"
              ? "na"
              : valData.validationVM.sim_cpu_utils_result === "*"
              ? "star"
              : valData.validationVM.sim_cpu_utils_result === null
              ? "skip"
              : valData.validationVM.sim_cpu_utils_result.toLowerCase();
          valHealth =
            valData.validationVM.sim_cpu_health_result === "N/A"
              ? "na"
              : valData.validationVM.sim_cpu_health_result === "*"
              ? "star"
              : valData.validationVM.sim_cpu_health_result === null
              ? "skip"
              : valData.validationVM.sim_cpu_health_result.toLowerCase();
        }
        ico = (
          <div
            className={this.state.fromOverview ? "" : "svgColorIconContainer"}
          >
            <div className="cpu-svg">
              <div id={"cpuCostTT" + tt} className="cost-tooltip-box">
                {costVal === "good" ? "$" : costVal === "fair" ? "$$" : "$$$"}
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 68 68">
                <path
                  id="cpu-cost"
                  className={costVal}
                  d={cpuCostIco}
                  onMouseOver={() => {
                    this.showToolTip("cpuCostTT" + tt);
                  }}
                  onMouseOut={() => {
                    this.hideToolTip("cpuCostTT" + tt);
                  }}
                />
                <path
                  id="cpu-health"
                  className={perfVal}
                  d={cpuPerfIco}
                  onMouseOver={() => {
                    this.showToolTip("cpuPerfTT" + tt);
                  }}
                  onMouseOut={() => {
                    this.hideToolTip("cpuPerfTT" + tt);
                  }}
                />
                {this.state.entityType === "db" ? (
                  <path
                    id="memory"
                    class="grayed-out"
                    d="M52.63,17.03H47.7a1.99,1.99,0,1,1-3.98,0H23.61a1.995,1.995,0,1,1-3.99,0H15.38a1.3507,1.3507,0,0,0-1.35,1.35V43.16a1.3423,1.3423,0,0,0,1.35,1.34h1.75v6.47h1.41V46.04h1.8v4.93h1.81V46.04h1.81v4.93h1.81V46.04h1.8v4.93h1.81V46.04h1.81v4.93H33V46.04h1.81v4.93h1.8V46.04h1.81v4.93h1.81V46.04h1.81v4.93h1.8V46.04h1.81v4.93h1.81V46.04h1.81v4.93h1.6V44.5h1.76a1.34,1.34,0,0,0,1.34-1.34V18.38A1.3487,1.3487,0,0,0,52.63,17.03ZM27.5,40.21a.8237.8237,0,0,1-.82.82H17.99a.8152.8152,0,0,1-.81-.82V24.71a.8066.8066,0,0,1,.81-.81h8.69a.8152.8152,0,0,1,.82.81Zm11.69,0a.8237.8237,0,0,1-.82.82H29.68a.8237.8237,0,0,1-.82-.82V24.71a.8152.8152,0,0,1,.82-.81h8.69a.8152.8152,0,0,1,.82.81Zm11.68,0a.8152.8152,0,0,1-.81.82H41.37a.8237.8237,0,0,1-.82-.82V24.71a.8152.8152,0,0,1,.82-.81h8.69a.8066.8066,0,0,1,.81.81Z"
                  />
                ) : null}
              </svg>
              <div
                id={"cpuPerfTT" + tt}
                className={"pref-tooltip-box pref-" + perfVal}
              ></div>
            </div>
          </div>
        );
        if (this.props.isResize === true) {
          let costResizeIconColor = costVal;
          let perfResizeIconColor = perfVal;

          if (type === "recommendation") {
            const costIndex =
              data[0]?.recommendationsIconColor?.costColor ?? -1;
            const healthIndex =
              data[0]?.recommendationsIconColor?.healthColor ?? -1;

            costResizeIconColor = colorStatusUtils[costIndex] ?? "na";
            perfResizeIconColor = colorStatusHealth[healthIndex] ?? "na";
          }

          resizeIco = (
            <div
              className={this.state.fromOverview ? "" : "svgGreyIconContainer"}
            >
              <div className="info-graphic-empty">
                {this.state.entityType === "db" ? (
                  <svg
                    id="vCoreCpuArrows"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 68 68"
                  >
                    {data[0].resize === message.Shrinking ? (
                      <g className="shrinking">
                        <polygon
                          className="arrow"
                          points="68 0.895 67.105 0 64.677 2.428 62.343 0.094 60.307 7.693 67.906 5.657 65.572 3.323 68 0.895"
                        />
                        <polygon
                          className="arrow"
                          points="7.693 7.693 5.657 0.094 3.323 2.428 0.895 0 0 0.895 2.428 3.323 0.094 5.657 7.693 7.693"
                        />
                        <polygon
                          className="arrow"
                          points="68 67.104 65.572 64.677 67.906 62.343 60.307 60.307 62.343 67.907 64.677 65.573 67.105 68 68 67.104"
                        />
                        <polygon
                          className="arrow"
                          points="7.693 60.307 0.094 62.343 2.428 64.677 0 67.104 0.895 68 3.323 65.573 5.657 67.907 7.693 60.307"
                        />
                      </g>
                    ) : data[0].resize === message.Growing ? (
                      <g class="growing">
                        <polygon
                          className="arrow"
                          points="60.307 6.797 61.203 7.693 63.63 5.265 65.964 7.599 68 0 60.401 2.036 62.735 4.37 60.307 6.797"
                        />
                        <polygon
                          className="arrow"
                          points="0 0 2.036 7.599 4.37 5.265 6.797 7.693 7.693 6.797 5.265 4.37 7.599 2.036 0 0"
                        />
                        <polygon
                          className="arrow"
                          points="60.307 61.203 62.735 63.63 60.401 65.964 68 68 65.964 60.401 63.63 62.735 61.203 60.307 60.307 61.203"
                        />
                        <polygon
                          className="arrow"
                          points="0 68 7.599 65.964 5.265 63.63 7.693 61.203 6.797 60.307 4.37 62.735 2.036 60.401 0 68"
                        />
                      </g>
                    ) : null}
                    <g id="cpu">
                      <path
                        className="cpu-fill"
                        d="M47.8867,59.7266V54.752H44.2959v4.9746H43.05V54.752H39.459v4.9746H38.2139V54.752H34.623v4.9746H33.3848V54.752H29.7866v4.9746H28.5483V54.752H24.95v4.9746H23.7119V54.752H20.1138v4.9746H18.8755V54.752H16.8574a3.61,3.61,0,0,1-3.6015-3.6094V49.125H8.2734V47.8867h4.9825V44.2959H8.2734V43.05h4.9825V39.459H8.2734V38.2139h4.9825V34.623H8.2734V33.3848h4.9825V29.7866H8.2734V28.5483h4.9825V24.95H8.2734V23.7119h4.9825V20.1138H8.2734V18.8755h4.9825V16.8574a3.6057,3.6057,0,0,1,3.6015-3.6015h1.9717V8.2734h1.2461v4.9825h3.59V8.2734h1.2461v4.9825h3.59V8.2734H29.74v4.9825h3.5987V8.2734h1.2382v4.9825h3.5977V8.2734h1.2383v4.9825h3.5986V8.2734H44.25v4.9825h3.59V8.2734h1.2461v4.9825h2.0567a3.61,3.61,0,0,1,3.6094,3.6015v2.0181h4.9746v1.2383H54.752v3.5981h4.9746V24.95H54.752v3.5981h4.9746v1.2383H54.752v3.5982h4.9746V34.623H54.752v3.5909h4.9746V39.459H54.752V43.05h4.9746v1.2461H54.752v3.5908h4.9746V49.125H54.752v2.0176a3.6135,3.6135,0,0,1-3.6094,3.6094H49.125v4.9746ZM20.0972,16.498a3.6035,3.6035,0,0,0-3.5992,3.5992V47.9033A3.6073,3.6073,0,0,0,20.0972,51.51H47.9023A3.6112,3.6112,0,0,0,51.51,47.9033V20.0972a3.6075,3.6075,0,0,0-3.6075-3.5992Z"
                      />
                      <path
                        className="cpu-border"
                        d="M48.7112,8.6486v4.9823h2.4313a3.2341,3.2341,0,0,1,3.2343,3.2266V19.25h4.9746v.4882H54.3768v4.3482h4.9746v.4883H54.3768v4.3482h4.9746v.4883H54.3768V33.76h4.9746v.4883H54.3768v4.34h4.9746v.4961H54.3768v4.34h4.9746v.496H54.3768v4.34h4.9746V48.75H54.3768v2.3929a3.238,3.238,0,0,1-3.2343,3.2343H48.75v4.9746h-.4883V54.3768h-4.34v4.9746h-.496V54.3768h-4.34v4.9746h-.496V54.3768h-4.34v4.9746H33.76V54.3768h-4.348v4.9746h-.4884V54.3768H24.5751v4.9746h-.4883V54.3768H19.7386v4.9746H19.25V54.3768H16.8575a3.2341,3.2341,0,0,1-3.2266-3.2343V48.75H8.6486v-.4883h4.9823v-4.34H8.6486v-.496h4.9823v-4.34H8.6486v-.4961h4.9823v-4.34H8.6486V33.76h4.9823V29.4116H8.6486v-.4883h4.9823V24.5751H8.6486v-.4883h4.9823V19.7386H8.6486V19.25h4.9823V16.8575a3.23,3.23,0,0,1,3.2266-3.2266h2.3468V8.6486H19.7v4.9823h4.34V8.6486h.496v4.9823h4.34V8.6486h.4884v4.9823h4.3481V8.6486h.4883v4.9823H38.55V8.6486h.4884v4.9823h4.3481V8.6486h.4883v4.9823h4.34V8.6486h.4959M20.0971,51.8848H47.9028a3.9865,3.9865,0,0,0,3.982-3.9819V20.0972a3.9826,3.9826,0,0,0-3.982-3.9743H20.0971a3.9787,3.9787,0,0,0-3.9742,3.9743V47.9029a3.9826,3.9826,0,0,0,3.9742,3.9819M49.4612,7.8986H47.4653v4.9823h-2.84V7.8986H42.6365v4.9823H39.7884V7.8986H37.8v4.9823H34.9519V7.8986H32.9636v4.9823H30.1155V7.8986H28.1271v4.9823h-2.84V7.8986h-1.996v4.9823H20.45V7.8986h-1.996v4.9823H16.8575a3.9774,3.9774,0,0,0-3.9766,3.9766V18.5H7.8986v1.9882h4.9823v2.8482H7.8986v1.9883h4.9823v2.8482H7.8986v1.9883h4.9823V33.01H7.8986V34.998h4.9823v2.84H7.8986v1.9961h4.9823v2.84H7.8986v1.996h4.9823v2.84H7.8986V49.5h4.9823v1.6429a3.979,3.979,0,0,0,3.9766,3.9843H18.5v4.9746h1.9882V55.1268h2.8482v4.9746h1.9883V55.1268h2.8481v4.9746h1.9884V55.1268H33.01v4.9746H34.998V55.1268h2.84v4.9746h1.996V55.1268h2.84v4.9746h1.996V55.1268h2.84v4.9746H49.5V55.1268h1.6429a3.9807,3.9807,0,0,0,3.9843-3.9843V49.5h4.9746V47.5113H55.1268v-2.84h4.9746v-1.996H55.1268v-2.84h4.9746V37.8384H55.1268v-2.84h4.9746V33.01H55.1268V30.1616h4.9746V28.1733H55.1268V25.3251h4.9746V23.3368H55.1268V20.4886h4.9746V18.5H55.1268V16.8575a3.979,3.979,0,0,0-3.9843-3.9766H49.4612V7.8986ZM20.0971,51.1348a3.23,3.23,0,0,1-3.2242-3.2319V20.0972a3.2238,3.2238,0,0,1,3.2242-3.2243H47.9028a3.23,3.23,0,0,1,3.232,3.2243V47.9029a3.237,3.237,0,0,1-3.232,3.2319Z"
                      />
                    </g>
                    <path
                      className="mem-border"
                      d="M48.3021,20.9724H44.5173a1.5277,1.5277,0,1,1-3.0554,0H26.0237a1.5316,1.5316,0,1,1-3.0631,0h-3.255a1.0368,1.0368,0,0,0-1.0363,1.0363V41.032a1.03,1.03,0,0,0,1.0363,1.0287h1.3435v4.967h1.0824V43.243h1.3819v3.7847h1.3895V43.243h1.39v3.7847h1.3895V43.243h1.3818v3.7847h1.3895V43.243h1.39v3.7847h1.39V43.243h1.3895v3.7847h1.3819V43.243h1.3895v3.7847h1.3895V43.243h1.3895v3.7847h1.3819V43.243h1.3894v3.7847h1.39V43.243h1.3895v3.7847h1.2283v-4.967h1.3512a1.0287,1.0287,0,0,0,1.0286-1.0287V22.0087A1.0352,1.0352,0,0,0,48.3021,20.9724ZM29.01,38.7673a.6324.6324,0,0,1-.63.63H21.7093a.6258.6258,0,0,1-.6218-.63V26.8682a.6192.6192,0,0,1,.6218-.6219h6.6712a.6258.6258,0,0,1,.63.6219V38.7673Zm8.9743,0a.6324.6324,0,0,1-.63.63H30.6836a.6324.6324,0,0,1-.63-.63V26.8682a.6258.6258,0,0,1,.63-.6219h6.6712a.6258.6258,0,0,1,.63.6219V38.7673Zm8.9666,0a.6258.6258,0,0,1-.6218.63H39.6578a.6324.6324,0,0,1-.6294-.63V26.8682a.6258.6258,0,0,1,.6294-.6219h6.6713a.6192.6192,0,0,1,.6218.6219V38.7673Z"
                    />
                    <rect className="bondingBox" width="68" height="68" />
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 68 68">
                    {/* {data[0].resize === message.Growing ? (
                      <>
                        <g className="growing">
                        <polygon
                          className="arrow"
                          points="60.31 6.8 61.2 7.69 63.63 5.26 65.96 7.6 68 0 60.4 2.04 62.73 4.37 60.31 6.8"
                        />
                        <polygon
                          className="arrow"
                          points="0 0 2.04 7.6 4.37 5.26 6.8 7.69 7.69 6.8 5.26 4.37 7.6 2.04 0 0"
                        />
                        <polygon
                          className="arrow"
                          points="60.31 61.2 62.73 63.63 60.4 65.96 68 68 65.96 60.4 63.63 62.73 61.2 60.31 60.31 61.2"
                        />
                        <polygon
                          className="arrow"
                          points="0 68 7.6 65.96 5.26 63.63 7.69 61.2 6.8 60.31 4.37 62.73 2.04 60.4 0 68"
                        />
                      </g>
                      </>
                    ) : data[0].resize === message.Shrinking ? (
                      <>
                        <g className="shrinking">
                        <polygon
                          className="arrow"
                          points="68 0.9 67.1 0 64.7 2.4 62.3 0.1 60.3 7.7 67.9 5.7 65.6 3.3 68 0.9"
                        />
                        <polygon
                          className="arrow"
                          points="7.7 7.7 5.7 0.1 3.3 2.4 0.9 0 0 0.9 2.4 3.3 0.1 5.7 7.7 7.7"
                        />
                        <polygon
                          className="arrow"
                          points="68 67.1 65.6 64.7 67.9 62.3 60.3 60.3 62.3 67.9 64.7 65.6 67.1 68 68 67.1"
                        />
                        <polygon
                          className="arrow"
                          points="7.7 60.3 0.1 62.3 2.4 64.7 0 67.1 0.9 68 3.3 65.6 5.7 67.9 7.7 60.3"
                        />
                      </g>
                      </>
                    ) : null} */}

                    <g id="cpuArrowIcon">
                      <path
                        id="cpuIconPart2"
                        className={costResizeIconColor}
                        d={cpuCostIco}
                      />
                      <path
                        id="cpuIconPart1"
                        className={perfResizeIconColor}
                        d={cpuPerfIco}
                      />
                    </g>

                    {/* <g id="cpuArrowIcon">
                      <path
                        className="cpuIconPart2"
                        d="M46.8,57.9V53.4H43.1v4.5h-.8V53.4H38.7v4.5h-.9V53.4H34.2v4.5h-.8V53.4H29.8v4.5h-.9V53.4H25.3v4.5h-.8V53.4H20.8v4.5H20V53.4H18a3.3,3.3,0,0,1-3.2-3.2v-2H10.2v-.9h4.6V43.7H10.2v-.8h4.6V39.3H10.2v-.9h4.6V34.8H10.2V34h4.6V30.3H10.2v-.8h4.6V25.9H10.2V25h4.6V21.4H10.2v-.8h4.6v-2A3.2,3.2,0,0,1,18,15.4h2V10.8h.8v4.6h3.6V10.8h.9v4.6h3.6V10.8h.8v4.6h3.6V10.8h.9v4.6h3.6V10.8h.8v4.6h3.7V10.8h.8v4.6h3.6V10.8h.9v4.6h2a3.2,3.2,0,0,1,3.2,3.2v2h4.6v.8H52.8V25h4.6v.9H52.8v3.6h4.6v.8H52.8V34h4.6v.8H52.8v3.6h4.6v.9H52.8v3.6h4.6v.8H52.8v3.6h4.6v.9H52.8v2a3.2,3.2,0,0,1-3.2,3.2h-2v4.5ZM24,21.8a2.8,2.8,0,0,0-2.8,2.8V44.2A2.9,2.9,0,0,0,24,47H43.6a2.8,2.8,0,0,0,2.8-2.8V24.6a2.7,2.7,0,0,0-2.8-2.8Z"
                      />
                      <path
                        className="cpuIconPart1"
                        d="M49.6,15.9a2.7,2.7,0,0,1,2.7,2.7V50.2a2.7,2.7,0,0,1-2.7,2.7H18a2.7,2.7,0,0,1-2.7-2.7V18.6A2.7,2.7,0,0,1,18,15.9H49.6M24,47.5H43.6a3.3,3.3,0,0,0,3.3-3.3V24.6a3.3,3.3,0,0,0-3.3-3.3H24a3.3,3.3,0,0,0-3.3,3.3V44.2A3.3,3.3,0,0,0,24,47.5M48.1,10.3H46.2v4.6H43.6V10.3H41.8v4.6H39.1V10.3H37.3v4.6H34.7V10.3H32.8v4.6H30.2V10.3H28.4v4.6H25.8V10.3H23.9v4.6H21.3V10.3H19.5v4.6H18a3.7,3.7,0,0,0-3.7,3.7v1.5H9.7v1.8h4.6v2.6H9.7v1.9h4.6V29H9.7v1.8h4.6v2.7H9.7v1.8h4.6v2.6H9.7v1.9h4.6v2.6H9.7v1.8h4.6v2.6H9.7v1.9h4.6v1.5A3.8,3.8,0,0,0,18,53.9h1.5v4.5h1.8V53.9H24v4.5h1.8V53.9h2.6v4.5h1.9V53.9h2.6v4.5h1.8V53.9h2.6v4.5h1.9V53.9h2.6v4.5h1.8V53.9h2.7v4.5h1.8V53.9h1.5a3.8,3.8,0,0,0,3.7-3.7V48.7h4.6V46.8H53.3V44.2h4.6V42.4H53.3V39.8h4.6V37.9H53.3V35.3h4.6V33.5H53.3V30.8h4.6V29H53.3V26.4h4.6V24.5H53.3V21.9h4.6V20.1H53.3V18.6a3.7,3.7,0,0,0-3.7-3.7H48.1V10.3ZM24,46.5a2.3,2.3,0,0,1-2.3-2.3V24.6A2.3,2.3,0,0,1,24,22.3H43.6a2.3,2.3,0,0,1,2.3,2.3V44.2a2.3,2.3,0,0,1-2.3,2.3Z"
                      />
                    </g> */}
                    <rect className="bondingBox" width="80" height="80" />
                  </svg>
                )}
              </div>
            </div>
          );
          if (validationIndicator === 1) {
            resizeIco = (
              <div
                className={
                  this.state.fromOverview ? "" : "svgColorIconContainer"
                }
              >
                <div className="cpu-svg">
                  <div id={"cpuCostValTT" + tt} className="cost-tooltip-box">
                    {valData.validationVM.sim_rec_cpu_cost.toLowerCase() ===
                    "good"
                      ? "$"
                      : valData.validationVM.sim_rec_cpu_cost.toLowerCase() ===
                        "fair"
                      ? "$$"
                      : "$$$"}
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 68 68">
                    <path
                      id="cpu-cost"
                      className={valData.validationVM.sim_rec_cpu_cost.toLowerCase()}
                      d="M61.52,32.7H68V34H50.79V20.38a3.171,3.171,0,0,0-3.17-3.17H20.38a3.171,3.171,0,0,0-3.17,3.17V34H0V32.7H6.48V29H0V26.4H6.48V22.7H0V20.11H6.48V16.4H0V13.81H6.48V11.67a5.1982,5.1982,0,0,1,5.19-5.19h2.08V0h2.6V6.48h3.7V0h2.59V6.48h3.71V0h2.59V6.48h3.71V0h2.59V6.48h3.71V0h2.59V6.48h3.7V0h2.6V6.48h3.7V0h2.6V6.48h2.19a5.1982,5.1982,0,0,1,5.19,5.19v2.14H68V16.4H61.52v3.71H68V22.7H61.52v3.7H68V29H61.52Z"
                      onMouseOver={() => {
                        this.showToolTip("cpuCostValTT" + tt);
                      }}
                      onMouseOut={() => {
                        this.hideToolTip("cpuCostValTT" + tt);
                      }}
                    />
                    <path
                      id="cpu-health"
                      className={valData.validationVM.sim_rec_cpu_health.toLowerCase()}
                      d="M61.52,51.6H68v2.59H61.52v2.14a5.1982,5.1982,0,0,1-5.19,5.19H54.19V68H51.6V61.52H47.89V68H45.3V61.52H41.6V68H39V61.52H35.3V68H32.7V61.52H29V68H26.4V61.52H22.7V68H20.11V61.52H16.4V68H13.81V61.52H11.67a5.1982,5.1982,0,0,1-5.19-5.19V54.19H0V51.6H6.48V47.89H0V45.3H6.48V41.6H0V39H6.48V35.3H0V34H17.21V47.62a3.171,3.171,0,0,0,3.17,3.17H47.62a3.171,3.171,0,0,0,3.17-3.17V34H68v1.3H61.52V39H68v2.6H61.52v3.7H68v2.59H61.52Z"
                      onMouseOver={() => {
                        this.showToolTip("cpuPerfValTT" + tt);
                      }}
                      onMouseOut={() => {
                        this.hideToolTip("cpuPerfValTT" + tt);
                      }}
                    />
                  </svg>
                  <div
                    id={"cpuPerfValTT" + tt}
                    className={
                      "pref-tooltip-box pref-" +
                      valData.validationVM.sim_rec_cpu_health.toLowerCase()
                    }
                  ></div>
                </div>
              </div>
            );
            rightArrow = (
              <div class="small-icon-container">
                <div className={"cost-small-icon " + valUtil + "-tick"}></div>
                <div class="arrow-right"></div>
                <div class={"pref-small-icon " + valHealth + "-tick"}></div>
              </div>
            );
          }
        }
        if (this.props.isIcon === true) {
          let curStatus =
            validationIndicator === 2 || data[0].status === null
              ? "pending"
              : data[0].status.toLowerCase();
          resizeStatusIcon = (
            <div className="state-container-resize">
              <div className="state-icon-resize">
                <div
                  className={"state-icon " + curStatus}
                  title={curStatus.toUpperCase()}
                ></div>
              </div>
            </div>
          );
          if (validationIndicator === 1) {
            resizeStatusIcon = (
              <div className="state-container">
                <div class="space-filler"></div>
                <div class="state-name1">Current</div>
                <div class="state-name2">{this.props.valObjective}</div>
              </div>
            );
            rightArrow = (
              <div class="small-icon-container">
                <div className={"cost-small-icon " + valUtil + "-tick"}></div>
                <div class="arrow-right"></div>
                <div class={"pref-small-icon " + valHealth + "-tick"}></div>
              </div>
            );
          }
        }
        break;
      case "memory":
        if (validationIndicator === 1) {
          costVal = valData.validationVM.sim_current_memory_cost.toLowerCase();
          perfVal =
            valData.validationVM.sim_current_memory_health.toLowerCase();
          valUtil =
            valData.validationVM.sim_memory_utils_result === "N/A"
              ? "na"
              : valData.validationVM.sim_memory_utils_result === "*"
              ? "star"
              : valData.validationVM.sim_memory_utils_result === null
              ? "skip"
              : valData.validationVM.sim_memory_utils_result.toLowerCase();
          valHealth =
            valData.validationVM.sim_memory_health_result === "N/A"
              ? "na"
              : valData.validationVM.sim_memory_health_result === "*"
              ? "star"
              : valData.validationVM.sim_memory_health_result === null
              ? "skip"
              : valData.validationVM.sim_memory_health_result.toLowerCase();
        }

        ico =
          this.state.entityType === "db" ? (
            <div
              className={this.state.fromOverview ? "" : "svgColorIconContainer"}
            >
              <div className="data-disk-svg">
                <div id={"ddCostTT" + tt} className="cost-tooltip-box">
                  {costVal === "good" ? "$" : costVal === "fair" ? "$$" : "$$$"}
                </div>
                <svg
                  id="DataDisk"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 52.641 68"
                >
                  <path
                    id="dbDisk-cost"
                    className={costVal}
                    d="M60.3205,26.3655v6.4038H53.0362a18.8633,18.8633,0,0,0-4.0924-11.817,19.0671,19.0671,0,0,0-20.8123-6.2837A19.038,19.038,0,0,0,14.9638,32.7693H7.68V26.3655A1.4255,1.4255,0,0,1,8.58,25.0247a2.5124,2.5124,0,0,0,1.601-2.3414v-.04A2.5052,2.5052,0,0,0,8.58,20.352,1.4293,1.4293,0,0,1,7.68,19.0012V4.0024A4.0013,4.0013,0,0,1,11.6819,0H56.3181a4.0013,4.0013,0,0,1,4.0024,4.0024V19.0012A1.4293,1.4293,0,0,1,59.42,20.352a2.49,2.49,0,0,0-1.601,2.2913v.04a2.4979,2.4979,0,0,0,1.601,2.3414A1.4255,1.4255,0,0,1,60.3205,26.3655Z"
                    transform="translate(-7.6795)"
                    onMouseOver={() => {
                      this.showToolTip("ddCostTT" + tt);
                    }}
                    onMouseOut={() => {
                      this.hideToolTip("ddCostTT" + tt);
                    }}
                  />
                  <path
                    id="dbDisk-performance"
                    className={perfVal}
                    d="M33.5447,43.5256c1.3208,2.8217,2.6216,5.6733,3.9223,8.505q2.3565,5.103,4.7028,10.196a3.9869,3.9869,0,0,0,.56.67,10.2718,10.2718,0,0,0,1.0006-.49q3.0318-2.0562,6.0536-4.1324a2.7452,2.7452,0,0,0,.51-.45.6608.6608,0,0,0,.07-.92,1.05,1.05,0,0,0-.12-.1c-.6-.57-1.1607-1.1807-1.7411-1.781Q42.17,48.4485,35.8061,41.8846a.9565.9565,0,0,0-.81-.24,5.773,5.773,0,0,0-1.3708.92C33.3446,42.8052,33.3646,43.1454,33.5447,43.5256Zm-2.1212.9306a3.6329,3.6329,0,0,1-.3-1.701,4.0357,4.0357,0,0,1,3.0418-3.322,2.863,2.863,0,0,1,3.1919.64c.53.52,1.0406,1.0606,1.5409,1.6009.6.64,1.2007,1.2808,1.8311,1.8911,1.0005.9706,2.0211,1.8911,3.1018,2.8617.44.4.88.79,1.3208,1.2007l.43.39.28-.42a18.9,18.9,0,0,0,7.0441-12.6474,17.7149,17.7149,0,0,0,.13-2.1813h7.2843v8.8852a1.4354,1.4354,0,0,1-.9005,1.3408,2.5052,2.5052,0,0,0,0,4.6727,1.4256,1.4256,0,0,1,.9005,1.3408V63.9976A4.0013,4.0013,0,0,1,56.3181,68H11.6819A4.0013,4.0013,0,0,1,7.68,63.9976V49.0088A1.4256,1.4256,0,0,1,8.58,47.668a2.5052,2.5052,0,0,0,0-4.6727A1.4354,1.4354,0,0,1,7.68,41.6545V32.7693h7.2843A19.0489,19.0489,0,0,0,33.945,51.7705h.63l-.13-.61a3.0656,3.0656,0,0,0-.13-.4c-.28-.61-.57-1.2308-.86-1.8511C32.7743,47.4579,32.0739,45.947,31.4235,44.4562Z"
                    transform="translate(-7.6795)"
                    onMouseOver={() => {
                      this.showToolTip("ddPerfTT" + tt);
                    }}
                    onMouseOut={() => {
                      this.hideToolTip("ddPerfTT" + tt);
                    }}
                  />
                  <circle
                    className="center"
                    cx="26.3205"
                    cy="32.7693"
                    r="4.0606"
                  />
                </svg>
                <div
                  id={"ddPerfTT" + tt}
                  className={"pref-tooltip-box pref-" + perfVal}
                ></div>
              </div>
            </div>
          ) : (
            <div
              className={this.state.fromOverview ? "" : "svgColorIconContainer"}
            >
              <div className="memory-svg">
                {isGreyedOut ? null : (
                  <div id={"ddCostTT" + tt} className="cost-tooltip-box">
                    {costVal === "good"
                      ? "$"
                      : costVal === "fair"
                      ? "$$"
                      : "$$$"}
                  </div>
                )}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 68">
                  <path
                    id="mem-cost"
                    className={isGreyedOut ? "na" : costVal}
                    d="M29.7131,15.38V34h-2.73V15.38a1.6325,1.6325,0,0,0-1.64-1.63H7.9331a1.63,1.63,0,0,0-1.63,1.63V34h-6.3V2.69A2.6908,2.6908,0,0,1,2.6931,0h8.51a3.9882,3.9882,0,0,0,3.99,3.99A3.9946,3.9946,0,0,0,19.1831,0h40.31a3.9882,3.9882,0,0,0,3.99,3.99A3.9946,3.9946,0,0,0,67.4731,0h9.86a2.6908,2.6908,0,0,1,2.69,2.69V34h-6.2V15.38a1.6389,1.6389,0,0,0-1.64-1.63h-17.41a1.6389,1.6389,0,0,0-1.64,1.63V34h-2.73V15.38a1.6325,1.6325,0,0,0-1.64-1.63h-17.41A1.6389,1.6389,0,0,0,29.7131,15.38Z"
                    transform="translate(-0.0031)"
                    onMouseOver={() => {
                      this.showToolTip("ddCostTT" + tt);
                    }}
                    onMouseOut={() => {
                      this.hideToolTip("ddCostTT" + tt);
                    }}
                  />
                  <path
                    id="mem-health"
                    className={isGreyedOut ? "na" : perfVal}
                    d="M29.7131,46.44a1.641,1.641,0,0,0,1.64,1.64h17.41a1.6346,1.6346,0,0,0,1.64-1.64V34h2.73V46.44a1.641,1.641,0,0,0,1.64,1.64h17.41a1.641,1.641,0,0,0,1.64-1.64V34h6.2V52.34a2.6844,2.6844,0,0,1-2.69,2.69h-3.51V68h-3.22V58.12h-3.62V68h-3.63V58.12h-3.62V68h-3.62V58.12h-3.62V68h-3.63V58.12h-3.62V68h-3.62V58.12h-3.62V68h-3.62V58.12h-3.63V68h-3.62V58.12h-3.62V68h-3.62V58.12h-3.63V68h-3.62V58.12h-3.62V68h-2.82V55.03h-3.51a2.6844,2.6844,0,0,1-2.69-2.69V34h6.3V46.44a1.6325,1.6325,0,0,0,1.63,1.64h17.41a1.6346,1.6346,0,0,0,1.64-1.64V34h2.73Z"
                    transform="translate(-0.0031)"
                    onMouseOver={() => {
                      this.showToolTip("ddPerfTT" + tt);
                    }}
                    onMouseOut={() => {
                      this.hideToolTip("ddPerfTT" + tt);
                    }}
                  />
                </svg>
                {isGreyedOut ? null : (
                  <div
                    id={"ddPerfTT" + tt}
                    className={"pref-tooltip-box pref-" + perfVal}
                  ></div>
                )}
              </div>
            </div>
          );

        if (this.props.isResize === true) {
          let costResizeIconColor = costVal;
          let perfResizeIconColor = perfVal;

          if (type === "recommendation") {
            const costIndex =
              data[0]?.recommendationsIconColor?.costColor ?? -1;
            const healthIndex =
              data[0]?.recommendationsIconColor?.healthColor ?? -1;

            costResizeIconColor = colorStatusUtils[costIndex] ?? "na";
            perfResizeIconColor = colorStatusHealth[healthIndex] ?? "na";
          }

          resizeIco =
            this.state.entityType === "db" ? (
              <div
                className={
                  this.state.fromOverview ? "" : "svgGreyIconContainer"
                }
              >
                <div class="info-graphic-empty">
                  <svg
                    id="DataDiskGray"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 68 68"
                  >
                    <rect class="bondingBox" width="68" height="68" />
                    {data[0].resize === message.Growing ? (
                      <g class="growing">
                        <polygon
                          class="arrow"
                          points="68 0.895 67.105 0 64.677 2.428 62.343 0.094 60.307 7.693 67.906 5.657 65.572 3.323 68 0.895"
                        />
                        <polygon
                          class="arrow"
                          points="7.693 7.693 5.657 0.094 3.323 2.428 0.895 0 0 0.895 2.428 3.323 0.094 5.657 7.693 7.693"
                        />
                        <polygon
                          class="arrow"
                          points="68 67.104 65.572 64.677 67.906 62.343 60.307 60.307 62.343 67.907 64.677 65.573 67.105 68 68 67.104"
                        />
                        <polygon
                          class="arrow"
                          points="7.693 60.307 0.094 62.343 2.428 64.677 0 67.104 0.895 68 3.323 65.573 5.657 67.907 7.693 60.307"
                        />
                      </g>
                    ) : data[0].resize === message.Shrinking ? (
                      <g class="shrinking">
                        <polygon
                          class="arrow"
                          points="60.307 6.797 61.203 7.693 63.63 5.265 65.964 7.599 68 0 60.401 2.036 62.735 4.37 60.307 6.797"
                        />
                        <polygon
                          class="arrow"
                          points="0 0 2.036 7.599 4.37 5.265 6.797 7.693 7.693 6.797 5.265 4.37 7.599 2.036 0 0"
                        />
                        <polygon
                          class="arrow"
                          points="60.307 61.203 62.735 63.63 60.401 65.964 68 68 65.964 60.401 63.63 62.735 61.203 60.307 60.307 61.203"
                        />
                        <polygon
                          class="arrow"
                          points="0 68 7.599 65.964 5.265 63.63 7.693 61.203 6.797 60.307 4.37 62.735 2.036 60.401 0 68"
                        />
                      </g>
                    ) : null}
                    <path
                      class="data-disk"
                      d="M51.9435,24.3661a1.0087,1.0087,0,0,0,.6357-.9535V12.8252A2.8245,2.8245,0,0,0,49.754,10H18.246a2.8245,2.8245,0,0,0-2.8252,2.8252V23.4126a1.0087,1.0087,0,0,0,.6357.9535,1.7684,1.7684,0,0,1,1.13,1.6174v.0283a1.7735,1.7735,0,0,1-1.13,1.6527,1.0062,1.0062,0,0,0-.6357.9465V39.4032a1.0132,1.0132,0,0,0,.6357.9464,1.7684,1.7684,0,0,1,0,3.2984,1.0064,1.0064,0,0,0-.6357.9465v10.58A2.8244,2.8244,0,0,0,18.246,58H49.754a2.8244,2.8244,0,0,0,2.8252-2.8252v-10.58a1.0064,1.0064,0,0,0-.6357-.9465,1.7684,1.7684,0,0,1,0-3.2984,1.0132,1.0132,0,0,0,.6357-.9464V28.611a1.0062,1.0062,0,0,0-.6357-.9465,1.7634,1.7634,0,0,1-1.13-1.6527v-.0283A1.7582,1.7582,0,0,1,51.9435,24.3661ZM45.5021,50.817a1.94,1.94,0,0,1-.36.3178q-2.13,1.462-4.2732,2.917a7.23,7.23,0,0,1-.7062.3461,2.811,2.811,0,0,1-.3956-.4732q-1.6527-3.5916-3.32-7.1972c-.9182-1.9988-1.8363-4.0118-2.7687-6.0035-.1271-.2684-.1412-.5086.0566-.6781a4.0741,4.0741,0,0,1,.9676-.65.6753.6753,0,0,1,.5721.17q4.492,4.63,8.9629,9.2737c.41.4238.8052.8546,1.229,1.2572a.7535.7535,0,0,1,.0847.0707A.4665.4665,0,0,1,45.5021,50.817Zm1.8434-16.146a13.3411,13.3411,0,0,1-4.9723,8.9276l-.1978.2966-.3037-.2754c-.3108-.29-.6215-.565-.9323-.8476-.7628-.6851-1.4832-1.3349-2.19-2.02-.4449-.4308-.8687-.8829-1.2925-1.3349-.3531-.3814-.7133-.7628-1.0877-1.13a2.0209,2.0209,0,0,0-2.2531-.4521A2.8488,2.8488,0,0,0,31.9694,40.18a2.5654,2.5654,0,0,0,.2119,1.2007c.4591,1.0524.9535,2.1189,1.4338,3.143.2048.438.41.8759.6074,1.3067a2.1585,2.1585,0,0,1,.0918.2825l.0918.4308h-.445A13.4319,13.4319,0,1,1,47.4373,33.1313,12.5043,12.5043,0,0,1,47.3455,34.671Z"
                    />
                    <circle
                      class="diskCenter"
                      cx="34"
                      cy="33.1313"
                      r="2.8663"
                    />
                  </svg>
                </div>
              </div>
            ) : (
              <div
                className={
                  this.state.fromOverview ? "" : "svgGreyIconContainer"
                }
              >
                <div className="memory-svg">
                  <svg
                    id="memoryIconAnalysis"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 80 68"
                  >
                    <g id="cpuArrowIcon">
                      <path
                        id="mem-cost"
                        className={costResizeIconColor}
                        d="M29.7131,15.38V34h-2.73V15.38a1.6325,1.6325,0,0,0-1.64-1.63H7.9331a1.63,1.63,0,0,0-1.63,1.63V34h-6.3V2.69A2.6908,2.6908,0,0,1,2.6931,0h8.51a3.9882,3.9882,0,0,0,3.99,3.99A3.9946,3.9946,0,0,0,19.1831,0h40.31a3.9882,3.9882,0,0,0,3.99,3.99A3.9946,3.9946,0,0,0,67.4731,0h9.86a2.6908,2.6908,0,0,1,2.69,2.69V34h-6.2V15.38a1.6389,1.6389,0,0,0-1.64-1.63h-17.41a1.6389,1.6389,0,0,0-1.64,1.63V34h-2.73V15.38a1.6325,1.6325,0,0,0-1.64-1.63h-17.41A1.6389,1.6389,0,0,0,29.7131,15.38Z"
                        transform="translate(-0.0031)"
                      />
                      <path
                        id="mem-health"
                        className={perfResizeIconColor}
                        d="M29.7131,46.44a1.641,1.641,0,0,0,1.64,1.64h17.41a1.6346,1.6346,0,0,0,1.64-1.64V34h2.73V46.44a1.641,1.641,0,0,0,1.64,1.64h17.41a1.641,1.641,0,0,0,1.64-1.64V34h6.2V52.34a2.6844,2.6844,0,0,1-2.69,2.69h-3.51V68h-3.22V58.12h-3.62V68h-3.63V58.12h-3.62V68h-3.62V58.12h-3.62V68h-3.63V58.12h-3.62V68h-3.62V58.12h-3.62V68h-3.62V58.12h-3.63V68h-3.62V58.12h-3.62V68h-3.62V58.12h-3.63V68h-3.62V58.12h-3.62V68h-2.82V55.03h-3.51a2.6844,2.6844,0,0,1-2.69-2.69V34h6.3V46.44a1.6325,1.6325,0,0,0,1.63,1.64h17.41a1.6346,1.6346,0,0,0,1.64-1.64V34h2.73Z"
                        transform="translate(-0.0031)"
                      />
                    </g>
                    <rect class="bondingBox" width="72" height="68" />
                  </svg>
                </div>
              </div>
            );
          if (validationIndicator === 1) {
            resizeIco = (
              <div
                className={
                  this.state.fromOverview ? "" : "svgColorIconContainer"
                }
              >
                <div className="memory-svg">
                  <div id={"ddCostTTVal" + tt} className="cost-tooltip-box">
                    {valData.validationVM.sim_rec_memory_cost.toLowerCase() ===
                    "good"
                      ? "$"
                      : valData.validationVM.sim_rec_memory_cost.toLowerCase() ===
                        "fair"
                      ? "$$"
                      : "$$$"}
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 68">
                    <path
                      id="mem-cost"
                      className={valData.validationVM.sim_rec_memory_cost.toLowerCase()}
                      d="M29.7131,15.38V34h-2.73V15.38a1.6325,1.6325,0,0,0-1.64-1.63H7.9331a1.63,1.63,0,0,0-1.63,1.63V34h-6.3V2.69A2.6908,2.6908,0,0,1,2.6931,0h8.51a3.9882,3.9882,0,0,0,3.99,3.99A3.9946,3.9946,0,0,0,19.1831,0h40.31a3.9882,3.9882,0,0,0,3.99,3.99A3.9946,3.9946,0,0,0,67.4731,0h9.86a2.6908,2.6908,0,0,1,2.69,2.69V34h-6.2V15.38a1.6389,1.6389,0,0,0-1.64-1.63h-17.41a1.6389,1.6389,0,0,0-1.64,1.63V34h-2.73V15.38a1.6325,1.6325,0,0,0-1.64-1.63h-17.41A1.6389,1.6389,0,0,0,29.7131,15.38Z"
                      transform="translate(-0.0031)"
                      onMouseOver={() => {
                        this.showToolTip("ddCostTTVal" + tt);
                      }}
                      onMouseOut={() => {
                        this.hideToolTip("ddCostTTVal" + tt);
                      }}
                    />
                    <path
                      id="mem-health"
                      className={valData.validationVM.sim_rec_memory_health.toLowerCase()}
                      d="M29.7131,46.44a1.641,1.641,0,0,0,1.64,1.64h17.41a1.6346,1.6346,0,0,0,1.64-1.64V34h2.73V46.44a1.641,1.641,0,0,0,1.64,1.64h17.41a1.641,1.641,0,0,0,1.64-1.64V34h6.2V52.34a2.6844,2.6844,0,0,1-2.69,2.69h-3.51V68h-3.22V58.12h-3.62V68h-3.63V58.12h-3.62V68h-3.62V58.12h-3.62V68h-3.63V58.12h-3.62V68h-3.62V58.12h-3.62V68h-3.62V58.12h-3.63V68h-3.62V58.12h-3.62V68h-3.62V58.12h-3.63V68h-3.62V58.12h-3.62V68h-2.82V55.03h-3.51a2.6844,2.6844,0,0,1-2.69-2.69V34h6.3V46.44a1.6325,1.6325,0,0,0,1.63,1.64h17.41a1.6346,1.6346,0,0,0,1.64-1.64V34h2.73Z"
                      transform="translate(-0.0031)"
                      onMouseOver={() => {
                        this.showToolTip("ddPerfTTVal" + tt);
                      }}
                      onMouseOut={() => {
                        this.hideToolTip("ddPerfTTVal" + tt);
                      }}
                    />
                  </svg>
                  <div
                    id={"ddPerfTTVal" + tt}
                    className={
                      "pref-tooltip-box pref-" +
                      valData.validationVM.sim_rec_memory_health.toLowerCase()
                    }
                  ></div>
                </div>
              </div>
            );
          }
        }
        if (this.props.isIcon === true) {
          let curStatus =
            validationIndicator === 2 || data[0].status === null
              ? "pending"
              : data[0].status.toLowerCase();
          resizeStatusIcon = (
            <div className="state-container-resize">
              <div className="state-icon-resize">
                <div
                  className={"state-icon " + curStatus}
                  title={curStatus.toUpperCase()}
                ></div>
              </div>
            </div>
          );
          if (validationIndicator === 1) {
            resizeStatusIcon = (
              <div className="mem-state-container">
                <div className="mem-state-name1">Current</div>
                <div className="mem-state-name2">{this.props.valObjective}</div>
              </div>
            );
            rightArrow = (
              <div class="small-icon-container">
                <div className={"cost-small-icon " + valUtil + "-tick"}></div>
                <div class="arrow-right"></div>
                <div class={"pref-small-icon " + valHealth + "-tick"}></div>
              </div>
            );
          }
        }
        break;
      case "network":
        if (validationIndicator === 1) {
          costVal = valData.validationVM.sim_current_network_cost.toLowerCase();
          perfVal =
            valData.validationVM.sim_current_network_health.toLowerCase();
          valUtil =
            valData.validationVM.sim_network_utils_result === "N/A"
              ? "na"
              : valData.validationVM.sim_network_utils_result === "*"
              ? "star"
              : valData.validationVM.sim_network_utils_result === null
              ? "skip"
              : valData.validationVM.sim_network_utils_result.toLowerCase();
          valHealth =
            valData.validationVM.sim_network_health_result === "N/A"
              ? "na"
              : valData.validationVM.sim_network_health_result === "*"
              ? "star"
              : valData.validationVM.sim_network_health_result === null
              ? "skip"
              : valData.validationVM.sim_network_health_result.toLowerCase();
        }
        ico =
          this.state.entityType === "db" ? (
            <div
              className={this.state.fromOverview ? "" : "svgColorIconContainer"}
            >
              <div class="log-disk-svg">
                <div id={"netCostTT" + tt} className="cost-tooltip-box">
                  {costVal === "good" ? "$" : costVal === "fair" ? "$$" : "$$$"}
                </div>
                <svg
                  id="LogDisk"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 49.16 68"
                >
                  <path
                    class="center"
                    d="M33.98,31.33a3.6191,3.6191,0,0,0-3.62,3.62,3.2069,3.2069,0,0,0,.06.63,3.6085,3.6085,0,0,0,3.05,2.96h1.02a3.6086,3.6086,0,0,0,3.06-2.96,3.2069,3.2069,0,0,0,.06-.63A3.6212,3.6212,0,0,0,33.98,31.33Z"
                    transform="translate(-9.42)"
                  />
                  <path
                    id="logDisk-cost"
                    className={costVal}
                    d="M47.44,11.8l9.27-.01L46.79,1.87v9.28a.6387.6387,0,0,0,.2.46A.6316.6316,0,0,0,47.44,11.8Zm.01,2.65h-.01a3.3169,3.3169,0,0,1-2.33-.96,3.2464,3.2464,0,0,1-.94-1.91,3.0028,3.0028,0,0,1-.03-.43V0H12.04A2.614,2.614,0,0,0,9.42,2.61V34h7.24a16.8708,16.8708,0,0,1,.53-3.38H13.93V27.66h4.33c.09-.2.19-.4.29-.6a16.8789,16.8789,0,0,1,3.17-4.37H13.93V19.73H25.66a18.06,18.06,0,0,1,2.99-1.28,17.2128,17.2128,0,0,1,5.33-.85,17.4794,17.4794,0,0,1,8.35,2.13H53.36v2.96H46.3a17.3629,17.3629,0,0,1,1.33,1.5,18.0778,18.0778,0,0,1,2.13,3.47h3.6v2.96H50.81A16.6373,16.6373,0,0,1,51.33,34h7.25V14.43Zm-5.02.31H13.93V11.8h28.5Z"
                    transform="translate(-9.42)"
                    onMouseOver={() => {
                      this.showToolTip("netCostTT" + tt);
                    }}
                    onMouseOut={() => {
                      this.hideToolTip("netCostTT" + tt);
                    }}
                  />
                  <path
                    id="logDisk-health"
                    className={perfVal}
                    d="M33.59,44.65c1.19,2.54,2.36,5.1,3.53,7.67q2.115,4.59,4.24,9.17a3.2508,3.2508,0,0,0,.5.61,6.7927,6.7927,0,0,0,.9-.44c1.82-1.24,3.64-2.47,5.45-3.73a1.7692,1.7692,0,0,0,.46-.4.5785.5785,0,0,0,.06-.83.3845.3845,0,0,0-.09-.09c-.55-.51-1.05-1.06-1.57-1.6q-5.715-5.925-11.44-11.84a.8827.8827,0,0,0-.73-.22,5.84,5.84,0,0,0-1.24.83C33.4,44,33.43,44.31,33.59,44.65ZM13.93,35.58v2.96h3.1a15.55,15.55,0,0,0,.46,1.75,16.89,16.89,0,0,0,1.41,3.22H13.93v2.96h7.09a17.2846,17.2846,0,0,0,12.93,5.82h.83l-.18-.8a2.1167,2.1167,0,0,0-.13-.41c-.24-.55-.5-1.1-.77-1.65-.61-1.32-1.24-2.68-1.83-4.03a2.9675,2.9675,0,0,1-.26-1.41,3.3656,3.3656,0,0,1,2.53-2.79l.09-.04a2.348,2.348,0,0,1,2.64.53c.48.47.93.96,1.39,1.44.53.57,1.08,1.15,1.65,1.71.91.88,1.83,1.71,2.8,2.58.4.36.8.71,1.19,1.08l.53.48.39-.51a17.56,17.56,0,0,0,2.13-2h6.3V43.51H49.09a16.96,16.96,0,0,0,1.88-4.97h2.39V35.58H51.33a13.88,13.88,0,0,0,0-1.58h7.25V65.38A2.6162,2.6162,0,0,1,55.96,68H12.04a2.6162,2.6162,0,0,1-2.62-2.62V34h7.24c-.03.52-.03,1.05-.01,1.58Z"
                    transform="translate(-9.42)"
                    onMouseOver={() => {
                      this.showToolTip("netPerfTT" + tt);
                    }}
                    onMouseOut={() => {
                      this.hideToolTip("netPerfTT" + tt);
                    }}
                  />
                </svg>
                <div
                  id={"netPerfTT" + tt}
                  className={"pref-tooltip-box pref-" + perfVal}
                ></div>
              </div>
            </div>
          ) : (
            <div
              className={this.state.fromOverview ? "" : "svgColorIconContainer"}
            >
              <div className="network-svg">
                <div id={"netCostTT" + tt} className="cost-tooltip-box">
                  {costVal === "good" ? "$" : costVal === "fair" ? "$$" : "$$$"}
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 68">
                  <path
                    id="net-cost"
                    className={costVal}
                    d="M8.8782,33.11a2.68,2.68,0,0,1,2.74-2.3h23.7V24.07h-.5c-1.91,0-3.82.02-5.74-.01a2.648,2.648,0,0,1-2.55-2.73c0-3.11-.01-6.22-.01-9.33s.01-6.22.01-9.33a2.7048,2.7048,0,0,1,1.78-2.55,1.3557,1.3557,0,0,0,.39-.12h18.61a.2651.2651,0,0,0,.06.05,2.7471,2.7471,0,0,1,2.13,3.01V21.03a4.851,4.851,0,0,1-.05.85,2.6645,2.6645,0,0,1-2.7,2.21c-1.87.01-3.74,0-5.62,0h-.43v6.74h23.52a2.7216,2.7216,0,0,1,2.95,2.51,5.0454,5.0454,0,0,1,0,.55V34H8.8382v-.16A3.5393,3.5393,0,0,1,8.8782,33.11Zm34.3-16.37V7.67h-10.34v9.07Z"
                    transform="translate(0.0018)"
                    onMouseOver={() => {
                      this.showToolTip("netCostTT" + tt);
                    }}
                    onMouseOut={() => {
                      this.hideToolTip("netCostTT" + tt);
                    }}
                  />
                  <path
                    id="net-health"
                    className={perfVal}
                    d="M73.1982,43.88h-6.03V34H8.8382v9.88h-5.92c-1.56,0-2.87.65-2.87,2.23-.01.02-.05,13.01-.05,19.49.03.11.07.23.1.34a2.6567,2.6567,0,0,0,2.53,2.02q8.8652.015,17.72,0a2.6746,2.6746,0,0,0,2.63-2.61c.01-.16.01-.32.01-.49q.03-8.955,0-17.92a3.6215,3.6215,0,0,0-.22-1.39,2.5465,2.5465,0,0,0-2.51-1.69h-6.07V36.41h21.14v7.45h-5.93a3.53,3.53,0,0,0-.46,0,2.744,2.744,0,0,0-2.41,3.01v18.1a3.0854,3.0854,0,0,0,0,.43,2.6982,2.6982,0,0,0,2.85,2.57h17.29a2.5388,2.5388,0,0,0,.39,0,2.7474,2.7474,0,0,0,2.44-2.98V46.82a2.5387,2.5387,0,0,0,0-.39,2.68,2.68,0,0,0-2.8-2.57h-6V36.4h21.18v.41c0,2.21-.01,4.43,0,6.64.01.34-.08.43-.41.43-1.84-.02-3.68.04-5.51-.02-.1-.01-.2-.01-.3-.01a2.8779,2.8779,0,0,0-2.64,3.07q.075,9,0,18.01v.23a2.8813,2.8813,0,0,0,2.93,2.84c5.75-.05,11.5-.02,17.25-.02a2.6794,2.6794,0,0,0,2.77-2.31,2.8476,2.8476,0,0,0,.04-.65V46.85a2.2854,2.2854,0,0,0,0-.37A2.7017,2.7017,0,0,0,73.1982,43.88Zm-56.53,7.46v9.08H6.3282V51.34Zm26.51,0v9.08h-10.34V51.34Zm26.5443,9.08h-10.34V51.34h10.34Z"
                    transform="translate(0.0018)"
                    onMouseOver={() => {
                      this.showToolTip("netPerfTT" + tt);
                    }}
                    onMouseOut={() => {
                      this.hideToolTip("netPerfTT" + tt);
                    }}
                  />
                </svg>
                <div
                  id={"netPerfTT" + tt}
                  className={"pref-tooltip-box pref-" + perfVal}
                ></div>
              </div>
            </div>
          );
        if (this.props.isResize === true) {
          let costResizeIconColor = costVal;
          let perfResizeIconColor = perfVal;

          if (type === "recommendation") {
            const costIndex =
              data[0]?.recommendationsIconColor?.costColor ?? -1;
            const healthIndex =
              data[0]?.recommendationsIconColor?.healthColor ?? -1;

            costResizeIconColor = colorStatusUtils[costIndex] ?? "na";
            perfResizeIconColor = colorStatusHealth[healthIndex] ?? "na";
          }

          resizeIco =
            this.state.entityType === "db" ? (
              <div
                className={
                  this.state.fromOverview ? "" : "svgGreyIconContainer"
                }
              >
                <div class="log-disk-arrow-svg">
                  <svg
                    id="LogDiskGray"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 68 68"
                  >
                    <rect class="bondingBox" width="68" height="68" />
                    {data[0].resize === message.Shrinking ? (
                      <g class="shrinking">
                        <polygon
                          class="arrow"
                          points="68 0.895 67.105 0 64.677 2.428 62.343 0.094 60.307 7.693 67.906 5.657 65.572 3.323 68 0.895"
                        />
                        <polygon
                          class="arrow"
                          points="7.693 7.693 5.657 0.094 3.323 2.428 0.895 0 0 0.895 2.428 3.323 0.094 5.657 7.693 7.693"
                        />
                        <polygon
                          class="arrow"
                          points="68 67.104 65.572 64.677 67.906 62.343 60.307 60.307 62.343 67.907 64.677 65.573 67.105 68 68 67.104"
                        />
                        <polygon
                          class="arrow"
                          points="7.693 60.307 0.094 62.343 2.428 64.677 0 67.104 0.895 68 3.323 65.573 5.657 67.907 7.693 60.307"
                        />
                      </g>
                    ) : data[0].resize === message.Growing ? (
                      <g class="growing">
                        <polygon
                          class="arrow"
                          points="60.307 6.797 61.203 7.693 63.63 5.265 65.964 7.599 68 0 60.401 2.036 62.735 4.37 60.307 6.797"
                        />
                        <polygon
                          class="arrow"
                          points="0 0 2.036 7.599 4.37 5.265 6.797 7.693 7.693 6.797 5.265 4.37 7.599 2.036 0 0"
                        />
                        <polygon
                          class="arrow"
                          points="60.307 61.203 62.735 63.63 60.401 65.964 68 68 65.964 60.401 63.63 62.735 61.203 60.307 60.307 61.203"
                        />
                        <polygon
                          class="arrow"
                          points="0 68 7.599 65.964 5.265 63.63 7.693 61.203 6.797 60.307 4.37 62.735 2.036 60.401 0 68"
                        />
                      </g>
                    ) : null}
                    <path
                      class="log-disk"
                      d="M45.8659,31.607a12.0536,12.0536,0,0,0-.7412-2.0894,12.5492,12.5492,0,0,0-1.5035-2.4494,12.2636,12.2636,0,0,0-.9389-1.0588A12.5463,12.5463,0,0,0,39.88,23.92a12.3585,12.3585,0,0,0-5.8941-1.5036,12.1165,12.1165,0,0,0-3.7624.6,12.5915,12.5915,0,0,0-2.0964.9035,11.7185,11.7185,0,0,0-2.7883,2.0894,12.1092,12.1092,0,0,0-2.2447,3.0847c-.0706.1412-.1411.2823-.2047.4235A12.1245,12.1245,0,0,0,21.76,34c-.0212.367-.0212.7412-.007,1.1153a11.6747,11.6747,0,0,0,.2682,2.0894,10.861,10.861,0,0,0,.3247,1.2282,12.4643,12.4643,0,0,0,1.0024,2.28,11.9209,11.9209,0,0,0,1.4894,2.0894,12.2009,12.2009,0,0,0,9.127,4.1083h.5859l-.127-.5718a1.4533,1.4533,0,0,0-.0918-.2824c-.1695-.3882-.353-.7835-.5436-1.1717C33.3577,43.96,32.913,43,32.4965,42.047a2.1237,2.1237,0,0,1-.1836-1.0023,2.3844,2.3844,0,0,1,1.7859-1.9694l.0635-.0212a1.6458,1.6458,0,0,1,1.8636.3741c.3388.3318.6564.6706.9812,1.0165.3741.3953.7623.8117,1.1647,1.2.6423.6212,1.2917,1.207,1.9765,1.8282.2823.2471.5646.5012.84.7624l.374.3317.2754-.3529a12.399,12.399,0,0,0,1.5035-1.4118,12.1894,12.1894,0,0,0,2.8376-5.5976c.0777-.3671.1412-.7412.1835-1.1224.0354-.3247.0636-.6494.0707-.967a9.8331,9.8331,0,0,0,0-1.1153A11.8933,11.8933,0,0,0,45.8659,31.607Z"
                    />
                    <path
                      class="log-file"
                      d="M43.4941,20.1929h-.007a2.3217,2.3217,0,0,1-2.3083-2.0259,2.0957,2.0957,0,0,1-.0211-.2965V10H18.4988a1.8452,1.8452,0,0,0-1.8494,1.8423V56.1435A1.8528,1.8528,0,0,0,18.4988,58H49.5012a1.8528,1.8528,0,0,0,1.8494-1.8565V20.1859ZM19.8329,18.3223H39.9506v2.0894H19.8329Zm24.5224,32.28a1.4193,1.4193,0,0,1-.3247.2894q-1.9166,1.3236-3.8471,2.6259a5.9274,5.9274,0,0,1-.6353.3177,2.5474,2.5474,0,0,1-.3529-.4306c-.9953-2.16-1.9976-4.313-2.993-6.48-.8258-1.8071-1.6517-3.6142-2.4917-5.4071-.1129-.247-.1341-.4658.0494-.6141a3.87,3.87,0,0,1,.8753-.5859.6436.6436,0,0,1,.5153.1482q4.0341,4.1825,8.0753,8.3648c.3671.3741.72.7623,1.1082,1.1223a.57.57,0,0,1,.0635.0706A.4.4,0,0,1,44.3553,50.6023Zm3.3106-24.5929H42.6824a12.2476,12.2476,0,0,1,.9388,1.0588,12.5463,12.5463,0,0,1,1.5035,2.4494h2.5412v2.0895h-1.8A11.8913,11.8913,0,0,1,46.233,34a9.8313,9.8313,0,0,1,0,1.1152h1.4329v2.09H45.9788a11.79,11.79,0,0,1-1.3341,3.5082h2.9436v2.0894H43.1412a12.393,12.393,0,0,1-1.5036,1.4118l-.2752.3529-.3741-.3317c-.2753-.2612-.5577-.5153-.84-.7624-.6848-.6212-1.3342-1.207-1.9765-1.8282-.4024-.3883-.7906-.8047-1.1647-1.2-.3247-.3459-.6424-.6848-.9812-1.0165a1.6457,1.6457,0,0,0-1.8635-.3741l-.0636.0212a2.3844,2.3844,0,0,0-1.7859,1.9694,2.1224,2.1224,0,0,0,.1836,1.0023c.4165.953.8612,1.913,1.2918,2.8377.1905.3882.3741.7835.5435,1.1717a1.4555,1.4555,0,0,1,.0918.2824l.127.5718h-.5859a12.2012,12.2012,0,0,1-9.1271-4.1083H19.8329V40.7129h3.5154a12.4711,12.4711,0,0,1-1.0024-2.28,10.8455,10.8455,0,0,1-.3247-1.2282H19.8329v-2.09h1.92c-.0141-.3741-.0141-.7482.0071-1.1152a11.98,11.98,0,0,1,.3741-2.3929H19.8329V29.5176h3.0565c.0635-.1412.1342-.2823.2047-.4235a12.1092,12.1092,0,0,1,2.2447-3.0847H19.8329V23.92h8.2942a12.5807,12.5807,0,0,1,2.0965-.9035,12.1157,12.1157,0,0,1,3.7622-.6A12.3589,12.3589,0,0,1,39.88,23.92h7.7859Zm-4.1788-7.6871h6.5435L43.0283,11.32v6.5505a.451.451,0,0,0,.1411.3248A.446.446,0,0,0,43.4871,18.3223Z"
                    />
                    <path
                      class="diskCenter"
                      d="M33.9859,32.1082a2.5607,2.5607,0,0,0-2.5553,2.5624,2.2665,2.2665,0,0,0,.0423.4447,2.5474,2.5474,0,0,0,2.153,2.0894h.72a2.54,2.54,0,0,0,2.16-2.0894,2.2665,2.2665,0,0,0,.0423-.4447A2.5622,2.5622,0,0,0,33.9859,32.1082Z"
                    />
                  </svg>
                </div>
              </div>
            ) : (
              <div
                className={
                  this.state.fromOverview ? "" : "svgGreyIconContainer"
                }
              >
                <div class="network-svg">
                  <svg
                    id="networkArrowIconRecom"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 76 68"
                  >
                    <path
                      id="net-cost"
                      className={costResizeIconColor}
                      d="M8.8782,33.11a2.68,2.68,0,0,1,2.74-2.3h23.7V24.07h-.5c-1.91,0-3.82.02-5.74-.01a2.648,2.648,0,0,1-2.55-2.73c0-3.11-.01-6.22-.01-9.33s.01-6.22.01-9.33a2.7048,2.7048,0,0,1,1.78-2.55,1.3557,1.3557,0,0,0,.39-.12h18.61a.2651.2651,0,0,0,.06.05,2.7471,2.7471,0,0,1,2.13,3.01V21.03a4.851,4.851,0,0,1-.05.85,2.6645,2.6645,0,0,1-2.7,2.21c-1.87.01-3.74,0-5.62,0h-.43v6.74h23.52a2.7216,2.7216,0,0,1,2.95,2.51,5.0454,5.0454,0,0,1,0,.55V34H8.8382v-.16A3.5393,3.5393,0,0,1,8.8782,33.11Zm34.3-16.37V7.67h-10.34v9.07Z"
                      transform="translate(0.0018)"
                    />
                    <path
                      id="net-health"
                      className={perfResizeIconColor}
                      d="M73.1982,43.88h-6.03V34H8.8382v9.88h-5.92c-1.56,0-2.87.65-2.87,2.23-.01.02-.05,13.01-.05,19.49.03.11.07.23.1.34a2.6567,2.6567,0,0,0,2.53,2.02q8.8652.015,17.72,0a2.6746,2.6746,0,0,0,2.63-2.61c.01-.16.01-.32.01-.49q.03-8.955,0-17.92a3.6215,3.6215,0,0,0-.22-1.39,2.5465,2.5465,0,0,0-2.51-1.69h-6.07V36.41h21.14v7.45h-5.93a3.53,3.53,0,0,0-.46,0,2.744,2.744,0,0,0-2.41,3.01v18.1a3.0854,3.0854,0,0,0,0,.43,2.6982,2.6982,0,0,0,2.85,2.57h17.29a2.5388,2.5388,0,0,0,.39,0,2.7474,2.7474,0,0,0,2.44-2.98V46.82a2.5387,2.5387,0,0,0,0-.39,2.68,2.68,0,0,0-2.8-2.57h-6V36.4h21.18v.41c0,2.21-.01,4.43,0,6.64.01.34-.08.43-.41.43-1.84-.02-3.68.04-5.51-.02-.1-.01-.2-.01-.3-.01a2.8779,2.8779,0,0,0-2.64,3.07q.075,9,0,18.01v.23a2.8813,2.8813,0,0,0,2.93,2.84c5.75-.05,11.5-.02,17.25-.02a2.6794,2.6794,0,0,0,2.77-2.31,2.8476,2.8476,0,0,0,.04-.65V46.85a2.2854,2.2854,0,0,0,0-.37A2.7017,2.7017,0,0,0,73.1982,43.88Zm-56.53,7.46v9.08H6.3282V51.34Zm26.51,0v9.08h-10.34V51.34Zm26.5443,9.08h-10.34V51.34h10.34Z"
                      transform="translate(0.0018)"
                    />

                    <rect className="bondingBox" width="68" height="68" />
                  </svg>
                </div>
              </div>
            );
          if (validationIndicator === 1) {
            resizeIco = (
              <div
                className={
                  this.state.fromOverview ? "" : "svgColorIconContainer"
                }
              >
                <div className="network-svg">
                  <div id={"netCostTTVal" + tt} className="cost-tooltip-box">
                    {costVal === "good"
                      ? "$"
                      : costVal === "fair"
                      ? "$$"
                      : "$$$"}
                  </div>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 68">
                    <path
                      id="net-cost"
                      className={valData.validationVM.sim_rec_network_cost.toLowerCase()}
                      d="M8.8782,33.11a2.68,2.68,0,0,1,2.74-2.3h23.7V24.07h-.5c-1.91,0-3.82.02-5.74-.01a2.648,2.648,0,0,1-2.55-2.73c0-3.11-.01-6.22-.01-9.33s.01-6.22.01-9.33a2.7048,2.7048,0,0,1,1.78-2.55,1.3557,1.3557,0,0,0,.39-.12h18.61a.2651.2651,0,0,0,.06.05,2.7471,2.7471,0,0,1,2.13,3.01V21.03a4.851,4.851,0,0,1-.05.85,2.6645,2.6645,0,0,1-2.7,2.21c-1.87.01-3.74,0-5.62,0h-.43v6.74h23.52a2.7216,2.7216,0,0,1,2.95,2.51,5.0454,5.0454,0,0,1,0,.55V34H8.8382v-.16A3.5393,3.5393,0,0,1,8.8782,33.11Zm34.3-16.37V7.67h-10.34v9.07Z"
                      transform="translate(0.0018)"
                      onMouseOver={() => {
                        this.showToolTip("netCostTTVal" + tt);
                      }}
                      onMouseOut={() => {
                        this.hideToolTip("netCostTTVal" + tt);
                      }}
                    />
                    <path
                      id="net-health"
                      className={valData.validationVM.sim_rec_network_health.toLowerCase()}
                      d="M73.1982,43.88h-6.03V34H8.8382v9.88h-5.92c-1.56,0-2.87.65-2.87,2.23-.01.02-.05,13.01-.05,19.49.03.11.07.23.1.34a2.6567,2.6567,0,0,0,2.53,2.02q8.8652.015,17.72,0a2.6746,2.6746,0,0,0,2.63-2.61c.01-.16.01-.32.01-.49q.03-8.955,0-17.92a3.6215,3.6215,0,0,0-.22-1.39,2.5465,2.5465,0,0,0-2.51-1.69h-6.07V36.41h21.14v7.45h-5.93a3.53,3.53,0,0,0-.46,0,2.744,2.744,0,0,0-2.41,3.01v18.1a3.0854,3.0854,0,0,0,0,.43,2.6982,2.6982,0,0,0,2.85,2.57h17.29a2.5388,2.5388,0,0,0,.39,0,2.7474,2.7474,0,0,0,2.44-2.98V46.82a2.5387,2.5387,0,0,0,0-.39,2.68,2.68,0,0,0-2.8-2.57h-6V36.4h21.18v.41c0,2.21-.01,4.43,0,6.64.01.34-.08.43-.41.43-1.84-.02-3.68.04-5.51-.02-.1-.01-.2-.01-.3-.01a2.8779,2.8779,0,0,0-2.64,3.07q.075,9,0,18.01v.23a2.8813,2.8813,0,0,0,2.93,2.84c5.75-.05,11.5-.02,17.25-.02a2.6794,2.6794,0,0,0,2.77-2.31,2.8476,2.8476,0,0,0,.04-.65V46.85a2.2854,2.2854,0,0,0,0-.37A2.7017,2.7017,0,0,0,73.1982,43.88Zm-56.53,7.46v9.08H6.3282V51.34Zm26.51,0v9.08h-10.34V51.34Zm26.5443,9.08h-10.34V51.34h10.34Z"
                      transform="translate(0.0018)"
                      onMouseOver={() => {
                        this.showToolTip("netPerfTTVal" + tt);
                      }}
                      onMouseOut={() => {
                        this.hideToolTip("netPerfTTVal" + tt);
                      }}
                    />
                  </svg>
                  <div
                    id={"netPerfTTVal" + tt}
                    className={"pref-tooltip-box pref-" + perfVal}
                  ></div>
                </div>
              </div>
            );
          }
        }
        if (this.props.isIcon === true) {
          let curStatus =
            validationIndicator === 2 || data[0].status === null
              ? "pending"
              : data[0].status.toLowerCase();
          resizeStatusIcon = (
            <div className="state-container-resize">
              <div className="state-icon-resize">
                <div
                  className={"state-icon " + curStatus}
                  title={curStatus.toUpperCase()}
                ></div>
              </div>
            </div>
          );
          if (validationIndicator === 1) {
            resizeStatusIcon = (
              <div class="network-state-container">
                <div class="net-state-name1">Current</div>
                <div class="net-state-name2">{this.props.valObjective}</div>
              </div>
            );
            rightArrow = (
              <div class="small-icon-container">
                <div className={"cost-small-icon " + valUtil + "-tick"}></div>
                <div class="arrow-right"></div>
                <div class={"pref-small-icon " + valHealth + "-tick"}></div>
              </div>
            );
          }
        }
        break;
      default:
        var diskico = data.map((value, i) => {
          costVal = value?.costColor ? value.costColor.toLowerCase() : "na";
          perfVal = value?.healthColor ? value.healthColor.toLowerCase() : "na";

          if (value.icon === "osdisk") {
            return this.state.entityType === "db" ? (
              <div
                className={
                  this.state.fromOverview ? "" : "svgColorIconContainer"
                }
              >
                <div class="vCore-Mem-svg">
                  <div id={"osdCostTT" + tt} className="cost-tooltip-box">
                    {costVal === "good"
                      ? "$"
                      : costVal === "fair"
                      ? "$$"
                      : "$$$"}
                  </div>
                  <svg
                    id="vCoreMemory"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 68 68"
                  >
                    <path
                      id="mem-cost"
                      class={costVal}
                      d="M53.97,18.38V34h-3.1V24.71a.8066.8066,0,0,0-.81-.81H41.37a.8152.8152,0,0,0-.82.81V34H39.19V24.71a.8152.8152,0,0,0-.82-.81H29.68a.8152.8152,0,0,0-.82.81V34H27.5V24.71a.8152.8152,0,0,0-.82-.81H17.99a.8066.8066,0,0,0-.81.81V34H14.03V18.38a1.3507,1.3507,0,0,1,1.35-1.35h4.24a1.995,1.995,0,1,0,3.99,0H43.72a1.99,1.99,0,1,0,3.98,0h4.93A1.3487,1.3487,0,0,1,53.97,18.38Z"
                      onMouseOver={() => {
                        this.showToolTip("osdCostTT" + tt);
                      }}
                      onMouseOut={() => {
                        this.hideToolTip("osdCostTT" + tt);
                      }}
                    />
                    <path
                      id="mem-perf"
                      class={perfVal}
                      d="M53.97,34v9.16a1.34,1.34,0,0,1-1.34,1.34H50.87v6.47h-1.6V46.04H47.46v4.93H45.65V46.04H43.84v4.93h-1.8V46.04H40.23v4.93H38.42V46.04H36.61v4.93h-1.8V46.04H33v4.93H31.19V46.04H29.38v4.93H27.57V46.04h-1.8v4.93H23.96V46.04H22.15v4.93H20.34V46.04h-1.8v4.93H17.13V44.5H15.38a1.3423,1.3423,0,0,1-1.35-1.34V34h3.15v6.21a.8152.8152,0,0,0,.81.82h8.69a.8237.8237,0,0,0,.82-.82V34h1.36v6.21a.8237.8237,0,0,0,.82.82h8.69a.8237.8237,0,0,0,.82-.82V34h1.36v6.21a.8237.8237,0,0,0,.82.82h8.69a.8152.8152,0,0,0,.81-.82V34Z"
                      onMouseOver={() => {
                        this.showToolTip("osdPerfTT" + tt);
                      }}
                      onMouseOut={() => {
                        this.hideToolTip("osdPerfTT" + tt);
                      }}
                    />
                    <path
                      id="cpu"
                      class="grayed-out"
                      d="M68,16.4V13.81H61.52V11.67a5.1832,5.1832,0,0,0-5.19-5.18H54.14V0h-2.6V6.49h-3.7V0H45.25V6.49H41.54V0H38.95V6.49H35.24V0H32.65V6.49H28.94V0H26.35V6.49h-3.7V0h-2.6V6.49h-3.7V0h-2.6V6.49H11.67a5.1811,5.1811,0,0,0-5.18,5.18v2.14H0V16.4H6.49v3.71H0V22.7H6.49v3.71H0V29H6.49v3.71H0V35.3H6.49V39H0v2.6H6.49v3.7H0v2.6H6.49v3.7H0v2.59H6.49v2.14a5.1832,5.1832,0,0,0,5.18,5.19h2.14V68H16.4V61.52h3.71V68H22.7V61.52h3.71V68H29V61.52h3.71V68H35.3V61.52H39V68h2.6V61.52h3.7V68h2.6V61.52h3.7V68h2.59V61.52h2.14a5.1853,5.1853,0,0,0,5.19-5.19V54.19H68V51.6H61.52V47.9H68V45.3H61.52V41.6H68V39H61.52V35.3H68V32.71H61.52V29H68V26.41H61.52V22.7H68V20.11H61.52V16.4ZM56.32,52.11a4.2166,4.2166,0,0,1-4.21,4.21H15.89a4.208,4.208,0,0,1-4.2-4.21V15.89a4.2,4.2,0,0,1,4.2-4.2H52.11a4.208,4.208,0,0,1,4.21,4.2V52.11Z"
                    />
                  </svg>
                  <div
                    id={"osdPerfTT" + tt}
                    className={"pref-tooltip-box pref-" + perfVal}
                  ></div>
                </div>
              </div>
            ) : (
              <div className="os-disk-svg">
                <div id={"osdCostTT" + tt} className="cost-tooltip-box">
                  {(validationIndicator === 1
                    ? valData.validationOSDisk.sim_current_os_cost.toLowerCase()
                    : costVal) === "good"
                    ? "$"
                    : (validationIndicator === 1
                        ? valData.validationOSDisk.sim_current_os_cost.toLowerCase()
                        : costVal) === "fair"
                    ? "$$"
                    : "$$$"}
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 68">
                  <path
                    id="os-disk-cost"
                    className={
                      validationIndicator === 1
                        ? valData.validationOSDisk.sim_current_os_cost.toLowerCase()
                        : costVal
                    }
                    d="M26.28,33.05A4.9182,4.9182,0,0,0,24.4,34h6.09l-.15-.15A3.6174,3.6174,0,0,0,26.28,33.05ZM1.72,0C.47,0,0,.47,0,1.7V34H7.76c-.21-.5-.39-1-.56-1.52A20.0882,20.0882,0,1,1,44.85,34h7.18V0Z"
                    transform="translate(0.0016)"
                    onMouseOver={() => {
                      this.showToolTip("osdCostTT" + tt);
                    }}
                    onMouseOut={() => {
                      this.hideToolTip("osdCostTT" + tt);
                    }}
                  />
                  <g
                    id="os-disk-health"
                    className={
                      validationIndicator === 1
                        ? valData.validationOSDisk.sim_current_os_health.toLowerCase()
                        : perfVal
                    }
                    onMouseOver={() => {
                      this.showToolTip("osdPerfTT" + tt);
                    }}
                    onMouseOut={() => {
                      this.hideToolTip("osdPerfTT" + tt);
                    }}
                  >
                    <path
                      d="M28.27,36.2a.9925.9925,0,0,0-.87-.25,6.0434,6.0434,0,0,0-1.49.99c-.31.26-.28.63-.09,1.04,1.43,3.06,2.84,6.15,4.26,9.23q2.55,5.535,5.1,11.05a4.5984,4.5984,0,0,0,.59.73,10.0421,10.0421,0,0,0,1.09-.54q3.3-2.22,6.57-4.48a2.8406,2.8406,0,0,0,.55-.49.6981.6981,0,0,0,.07-.99.4263.4263,0,0,0-.12-.11c-.66-.61-1.26-1.28-1.89-1.93Q35.17,43.325,28.27,36.2ZM24.4,34h6.09c1.18,1.19,2.29,2.47,3.5,3.63,1.53,1.49,3.14,2.89,4.78,4.4l.01-.01A19.8889,19.8889,0,0,0,44.85,34h7.18v.02l-.03.01V68s-38.87,0-50.11-.01a2.17,2.17,0,0,1-1.31-.34,2.0005,2.0005,0,0,1-.56-1.34C-.01,58.49,0,34,0,34H7.76a20.0806,20.0806,0,0,0,18.5,12.38,1.6812,1.6812,0,0,0-.09-.32c-1.06-2.28-2.15-4.55-3.14-6.85a4.501,4.501,0,0,1-.38-2.14A4.847,4.847,0,0,1,24.4,34ZM12.16,60.14A4.0552,4.0552,0,0,0,8.19,56H8.11a4.0777,4.0777,0,0,0,0,8.14,4.0417,4.0417,0,0,0,4.04-4.01Z"
                      transform="translate(0.0016)"
                    />
                  </g>
                  <path
                    className="center"
                    d="M26.32,21.98a4.335,4.335,0,1,1-.05,0Z"
                    transform="translate(0.0016)"
                  />
                </svg>
                <div
                  id={"osdPerfTT" + tt}
                  className={
                    "pref-tooltip-box pref-" +
                    (validationIndicator === 1
                      ? valData.validationOSDisk.sim_current_os_health.toLowerCase()
                      : perfVal)
                  }
                ></div>
              </div>
            );
          } else if (data.length > i + 1) {
            return (
              <div className="mid-disk-svg">
                <div id={"dtCostTT" + tt + i} className="cost-tooltip-box">
                  {(validationIndicator === 1
                    ? valData.validationDataDisks[
                        i - 1
                      ].sim_current_datadisk_cost.toLowerCase()
                    : costVal) === "good"
                    ? "$"
                    : (validationIndicator === 1
                        ? valData.validationDataDisks[
                            i - 1
                          ].sim_current_datadisk_cost.toLowerCase()
                        : costVal) === "fair"
                    ? "$$"
                    : "$$$"}
                </div>
                <svg
                  id="diskMidIcon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 26 68"
                >
                  <path
                    className="center"
                    d="M-.0251,21.99a4.3433,4.3433,0,0,1,4.04,4.35,4.35,4.35,0,0,1-4.04,4.31Z"
                    transform="translate(0.0251)"
                  />
                  <path
                    id="dd-disk-cost"
                    className={
                      validationIndicator === 1
                        ? valData.validationDataDisks[
                            i - 1
                          ].sim_current_datadisk_cost.toLowerCase()
                        : costVal
                    }
                    d="M-.0251,32.93V34h3.89l-.15-.15A3.6,3.6,0,0,0-.0251,32.93Zm0-32.93V6.23a20.006,20.006,0,0,1,15.49,7.62A19.995,19.995,0,0,1,18.2249,34h7.78V0Z"
                    transform="translate(0.0251)"
                    onMouseOver={() => {
                      this.showToolTip("dtCostTT" + tt + i);
                    }}
                    onMouseOut={() => {
                      this.hideToolTip("dtCostTT" + tt + i);
                    }}
                  />
                  <g
                    id="dd-disk-health"
                    className={
                      validationIndicator === 1
                        ? valData.validationDataDisks[
                            i - 1
                          ].sim_current_datadisk_health.toLowerCase()
                        : perfVal
                    }
                    onMouseOver={() => {
                      this.showToolTip("dtPerfTT" + tt + i);
                    }}
                    onMouseOut={() => {
                      this.hideToolTip("dtPerfTT" + tt + i);
                    }}
                  >
                    <path
                      d="M.7749,35.95a6.2954,6.2954,0,0,0-.8.45V34h3.89c1.18,1.19,2.29,2.47,3.5,3.63,1.53,1.49,3.14,2.89,4.78,4.4l.01-.01a19.8889,19.8889,0,0,0,6.07-8.02h7.78v.02l-.03.01V68h-26V39.67c1.17,2.5,2.32,5.02,3.48,7.54q2.55,5.535,5.1,11.05a4.5984,4.5984,0,0,0,.59.73,10.0421,10.0421,0,0,0,1.09-.54q3.3-2.22,6.57-4.48a2.8406,2.8406,0,0,0,.55-.49.6981.6981,0,0,0,.07-.99.4263.4263,0,0,0-.12-.11c-.66-.61-1.26-1.28-1.89-1.93q-6.87-7.125-13.77-14.25A.9925.9925,0,0,0,.7749,35.95Z"
                      transform="translate(0.0251)"
                    />
                  </g>
                  <rect className="shadow" width="3" height="68" />
                </svg>
                <div
                  id={"dtPerfTT" + tt + i}
                  className={
                    "pref-tooltip-box pref-" +
                    (validationIndicator === 1
                      ? valData.validationDataDisks[
                          i - 1
                        ].sim_current_datadisk_health.toLowerCase()
                      : perfVal)
                  }
                ></div>
              </div>
            );
          } else if (data.length === i + 1) {
            return (
              <div className="end-disk-svg">
                <div id={"dtCostTT" + tt + i} className="cost-tooltip-box">
                  {(validationIndicator === 1
                    ? valData.validationDataDisks[
                        i - 1
                      ].sim_current_datadisk_cost.toLowerCase()
                    : costVal) === "good"
                    ? "$"
                    : (validationIndicator === 1
                        ? valData.validationDataDisks[
                            i - 1
                          ].sim_current_datadisk_cost.toLowerCase()
                        : costVal) === "fair"
                    ? "$$"
                    : "$$$"}
                </div>
                <svg
                  id="diskEndIcon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 26 68"
                >
                  <path
                    className="center"
                    d="M-.0251,21.99a4.3433,4.3433,0,0,1,4.04,4.35,4.35,4.35,0,0,1-4.04,4.31Z"
                    transform="translate(0.0251)"
                  />
                  <path
                    id="dd-disk-cost"
                    className={
                      validationIndicator === 1
                        ? valData.validationDataDisks[
                            i - 1
                          ].sim_current_datadisk_cost.toLowerCase()
                        : costVal
                    }
                    d="M-.0251,32.93V34h3.89l-.15-.15A3.6,3.6,0,0,0-.0251,32.93Zm0-32.93V6.23a20.006,20.006,0,0,1,15.49,7.62A19.995,19.995,0,0,1,18.2249,34h7.78V0Z"
                    transform="translate(0.0251)"
                    onMouseOver={() => {
                      this.showToolTip("dtCostTT" + tt + i);
                    }}
                    onMouseOut={() => {
                      this.hideToolTip("dtCostTT" + tt + i);
                    }}
                  />
                  <g
                    id="dd-disk-health"
                    className={
                      validationIndicator === 1
                        ? valData.validationDataDisks[
                            i - 1
                          ].sim_current_datadisk_health.toLowerCase()
                        : perfVal
                    }
                    onMouseOver={() => {
                      this.showToolTip("dtPerfTT" + tt + i);
                    }}
                    onMouseOut={() => {
                      this.hideToolTip("dtPerfTT" + tt + i);
                    }}
                  >
                    <path
                      d="M.7749,35.95a6.2954,6.2954,0,0,0-.8.45V34h3.89c1.18,1.19,2.29,2.47,3.5,3.63,1.53,1.49,3.14,2.89,4.78,4.4l.01-.01a19.8889,19.8889,0,0,0,6.07-8.02h7.78v.02l-.03.01V68h-26V39.67c1.17,2.5,2.32,5.02,3.48,7.54q2.55,5.535,5.1,11.05a4.5984,4.5984,0,0,0,.59.73,10.0421,10.0421,0,0,0,1.09-.54q3.3-2.22,6.57-4.48a2.8406,2.8406,0,0,0,.55-.49.6981.6981,0,0,0,.07-.99.4263.4263,0,0,0-.12-.11c-.66-.61-1.26-1.28-1.89-1.93q-6.87-7.125-13.77-14.25A.9925.9925,0,0,0,.7749,35.95Z"
                      transform="translate(0.0251)"
                    />
                  </g>
                  <rect className="shadow" width="3" height="68" />
                </svg>
                <div
                  id={"dtPerfTT" + tt + i}
                  className={
                    "pref-tooltip-box pref-" +
                    (validationIndicator === 1
                      ? valData.validationDataDisks[
                          i - 1
                        ].sim_current_datadisk_health.toLowerCase()
                      : perfVal)
                  }
                ></div>
              </div>
            );
          }
        });
        ico = (
          <div
            className={
              this.state.fromOverview
                ? "svgValidationIcoContainer"
                : "svgColorIconContainer"
            }
          >
            {diskico}
          </div>
        );
        if (this.props.isResize === true) {
          var diskresizeIco = data.map((value, i) => {
            let costResizeIconColor = value?.costColor
              ? value.costColor.toLowerCase()
              : "na";
            let perfResizeIconColor = value?.healthColor
              ? value.healthColor.toLowerCase()
              : "na";

            if (type === "recommendation") {
              const costIndex =
                value?.recommendationsIconColor?.costColor ?? -1;
              const healthIndex =
                value?.recommendationsIconColor?.healthColor ?? -1;

              costResizeIconColor = colorStatusUtils[costIndex] ?? "na";
              perfResizeIconColor = colorStatusHealth[healthIndex] ?? "na";
            }

            if (value.icon === "osdisk") {
              return this.state.entityType === "db" ? (
                <div
                  className={
                    this.state.fromOverview ? "" : "svgGreyIconContainer"
                  }
                >
                  <div class="vCoreMem-info-graphic-empty">
                    <svg
                      id="vCoreMemoryArrows"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 68 68"
                    >
                      <rect class="bondingBox" width="68" height="68" />
                      {value.resize === message.Shrinking ? (
                        <g class="shrinking">
                          <polygon
                            class="arrow"
                            points="68 0.895 67.105 0 64.677 2.428 62.343 0.094 60.307 7.693 67.906 5.657 65.572 3.323 68 0.895"
                          />
                          <polygon
                            class="arrow"
                            points="7.693 7.693 5.657 0.094 3.323 2.428 0.895 0 0 0.895 2.428 3.323 0.094 5.657 7.693 7.693"
                          />
                          <polygon
                            class="arrow"
                            points="68 67.104 65.572 64.677 67.906 62.343 60.307 60.307 62.343 67.907 64.677 65.573 67.105 68 68 67.104"
                          />
                          <polygon
                            class="arrow"
                            points="7.693 60.307 0.094 62.343 2.428 64.677 0 67.104 0.895 68 3.323 65.573 5.657 67.907 7.693 60.307"
                          />
                        </g>
                      ) : value.resize === message.Growing ? (
                        <g class="growing">
                          <polygon
                            class="arrow"
                            points="60.307 6.797 61.203 7.693 63.63 5.265 65.964 7.599 68 0 60.401 2.036 62.735 4.37 60.307 6.797"
                          />
                          <polygon
                            class="arrow"
                            points="0 0 2.036 7.599 4.37 5.265 6.797 7.693 7.693 6.797 5.265 4.37 7.599 2.036 0 0"
                          />
                          <polygon
                            class="arrow"
                            points="60.307 61.203 62.735 63.63 60.401 65.964 68 68 65.964 60.401 63.63 62.735 61.203 60.307 60.307 61.203"
                          />
                          <polygon
                            class="arrow"
                            points="0 68 7.599 65.964 5.265 63.63 7.693 61.203 6.797 60.307 4.37 62.735 2.036 60.401 0 68"
                          />
                        </g>
                      ) : null}
                      <path
                        class="vCore-mem-icon"
                        d="M48.3021,20.9724H44.5173a1.5277,1.5277,0,1,1-3.0554,0H26.0237a1.5316,1.5316,0,1,1-3.0631,0h-3.255a1.0368,1.0368,0,0,0-1.0363,1.0363V41.032a1.03,1.03,0,0,0,1.0363,1.0287h1.3435v4.967h1.0824V43.243h1.3819v3.7847h1.3895V43.243h1.39v3.7847h1.3895V43.243h1.3818v3.7847h1.3895V43.243h1.39v3.7847h1.39V43.243h1.3895v3.7847h1.3819V43.243h1.3895v3.7847h1.3895V43.243h1.3895v3.7847h1.3819V43.243h1.3894v3.7847h1.39V43.243h1.3895v3.7847h1.2283v-4.967h1.3512a1.0287,1.0287,0,0,0,1.0286-1.0287V22.0087A1.0352,1.0352,0,0,0,48.3021,20.9724ZM29.01,38.7673a.6324.6324,0,0,1-.63.63H21.7093a.6258.6258,0,0,1-.6218-.63V26.8682a.6192.6192,0,0,1,.6218-.6219h6.6712a.6258.6258,0,0,1,.63.6219V38.7673Zm8.9743,0a.6324.6324,0,0,1-.63.63H30.6836a.6324.6324,0,0,1-.63-.63V26.8682a.6258.6258,0,0,1,.63-.6219h6.6712a.6258.6258,0,0,1,.63.6219V38.7673Zm8.9666,0a.6258.6258,0,0,1-.6218.63H39.6578a.6324.6324,0,0,1-.6294-.63V26.8682a.6258.6258,0,0,1,.6294-.6219h6.6713a.6192.6192,0,0,1,.6218.6219V38.7673Z"
                      />
                      <path
                        class="cpu-fill"
                        d="M60.1014,20.4886V18.5H55.1268V16.8575a3.979,3.979,0,0,0-3.9843-3.9766H49.4612V7.8986H47.4653v4.9823h-2.84V7.8986H42.6365v4.9823H39.7884V7.8986H37.8v4.9823H34.9519V7.8986H32.9636v4.9823H30.1155V7.8986H28.1271v4.9823h-2.84V7.8986h-1.996v4.9823H20.45V7.8986h-1.996v4.9823H16.8575a3.9774,3.9774,0,0,0-3.9766,3.9766V18.5H7.8986v1.9882h4.9823v2.8482H7.8986v1.9883h4.9823v2.8482H7.8986v1.9883h4.9823V33.01H7.8986V34.998h4.9823v2.84H7.8986v1.9961h4.9823v2.84H7.8986v1.996h4.9823v2.84H7.8986V49.5h4.9823v1.6429a3.979,3.979,0,0,0,3.9766,3.9843H18.5v4.9746h1.9882V55.1268h2.8482v4.9746h1.9883V55.1268h2.8481v4.9746h1.9884V55.1268H33.01v4.9746H34.998V55.1268h2.84v4.9746h1.996V55.1268h2.84v4.9746h1.996V55.1268h2.84v4.9746H49.5V55.1268h1.6429a3.9807,3.9807,0,0,0,3.9843-3.9843V49.5h4.9746V47.5114H55.1268v-2.84h4.9746v-1.996H55.1268v-2.84h4.9746V37.8384H55.1268v-2.84h4.9746V33.01H55.1268V30.1616h4.9746V28.1733H55.1268V25.3251h4.9746V23.3368H55.1268V20.4886ZM51.1348,47.9029a3.237,3.237,0,0,1-3.232,3.2319H20.0971a3.23,3.23,0,0,1-3.2242-3.2319V20.0972a3.2238,3.2238,0,0,1,3.2242-3.2243H47.9028a3.23,3.23,0,0,1,3.232,3.2243V47.9029Z"
                      />
                    </svg>
                  </div>
                </div>
              ) : (
                <div className="os-disk-svg">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 68">
                    <path
                      id="os-disk-cost"
                      className={
                        validationIndicator === 1
                          ? valData.validationOSDisk.sim_current_os_cost.toLowerCase()
                          : costResizeIconColor
                      }
                      d="M26.28,33.05A4.9182,4.9182,0,0,0,24.4,34h6.09l-.15-.15A3.6174,3.6174,0,0,0,26.28,33.05ZM1.72,0C.47,0,0,.47,0,1.7V34H7.76c-.21-.5-.39-1-.56-1.52A20.0882,20.0882,0,1,1,44.85,34h7.18V0Z"
                      transform="translate(0.0016)"
                    />
                    <g
                      id="os-disk-health"
                      className={
                        validationIndicator === 1
                          ? valData.validationOSDisk.sim_current_os_health.toLowerCase()
                          : perfResizeIconColor
                      }
                    >
                      <path
                        d="M28.27,36.2a.9925.9925,0,0,0-.87-.25,6.0434,6.0434,0,0,0-1.49.99c-.31.26-.28.63-.09,1.04,1.43,3.06,2.84,6.15,4.26,9.23q2.55,5.535,5.1,11.05a4.5984,4.5984,0,0,0,.59.73,10.0421,10.0421,0,0,0,1.09-.54q3.3-2.22,6.57-4.48a2.8406,2.8406,0,0,0,.55-.49.6981.6981,0,0,0,.07-.99.4263.4263,0,0,0-.12-.11c-.66-.61-1.26-1.28-1.89-1.93Q35.17,43.325,28.27,36.2ZM24.4,34h6.09c1.18,1.19,2.29,2.47,3.5,3.63,1.53,1.49,3.14,2.89,4.78,4.4l.01-.01A19.8889,19.8889,0,0,0,44.85,34h7.18v.02l-.03.01V68s-38.87,0-50.11-.01a2.17,2.17,0,0,1-1.31-.34,2.0005,2.0005,0,0,1-.56-1.34C-.01,58.49,0,34,0,34H7.76a20.0806,20.0806,0,0,0,18.5,12.38,1.6812,1.6812,0,0,0-.09-.32c-1.06-2.28-2.15-4.55-3.14-6.85a4.501,4.501,0,0,1-.38-2.14A4.847,4.847,0,0,1,24.4,34ZM12.16,60.14A4.0552,4.0552,0,0,0,8.19,56H8.11a4.0777,4.0777,0,0,0,0,8.14,4.0417,4.0417,0,0,0,4.04-4.01Z"
                        transform="translate(0.0016)"
                      />
                    </g>
                    <path
                      className="center"
                      d="M26.32,21.98a4.335,4.335,0,1,1-.05,0Z"
                      transform="translate(0.0016)"
                    />
                  </svg>
                </div>
              );
            } else if (data.length > i + 1) {
              return (
                <div className="mid-disk-svg">
                  <svg
                    id="midDiskIconRecom"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 26 68"
                  >
                    <path
                      className="center"
                      d="M-.0251,21.99a4.3433,4.3433,0,0,1,4.04,4.35,4.35,4.35,0,0,1-4.04,4.31Z"
                      transform="translate(0.0251)"
                    />
                    <path
                      id="dd-disk-cost"
                      className={
                        validationIndicator === 1
                          ? valData.validationDataDisks[
                              i - 1
                            ].sim_current_datadisk_cost.toLowerCase()
                          : costResizeIconColor
                      }
                      d="M-.0251,32.93V34h3.89l-.15-.15A3.6,3.6,0,0,0-.0251,32.93Zm0-32.93V6.23a20.006,20.006,0,0,1,15.49,7.62A19.995,19.995,0,0,1,18.2249,34h7.78V0Z"
                      transform="translate(0.0251)"
                    />
                    <g
                      id="dd-disk-health"
                      className={
                        validationIndicator === 1
                          ? valData.validationDataDisks[
                              i - 1
                            ].sim_current_datadisk_health.toLowerCase()
                          : perfResizeIconColor
                      }
                    >
                      <path
                        d="M.7749,35.95a6.2954,6.2954,0,0,0-.8.45V34h3.89c1.18,1.19,2.29,2.47,3.5,3.63,1.53,1.49,3.14,2.89,4.78,4.4l.01-.01a19.8889,19.8889,0,0,0,6.07-8.02h7.78v.02l-.03.01V68h-26V39.67c1.17,2.5,2.32,5.02,3.48,7.54q2.55,5.535,5.1,11.05a4.5984,4.5984,0,0,0,.59.73,10.0421,10.0421,0,0,0,1.09-.54q3.3-2.22,6.57-4.48a2.8406,2.8406,0,0,0,.55-.49.6981.6981,0,0,0,.07-.99.4263.4263,0,0,0-.12-.11c-.66-.61-1.26-1.28-1.89-1.93q-6.87-7.125-13.77-14.25A.9925.9925,0,0,0,.7749,35.95Z"
                        transform="translate(0.0251)"
                      />
                    </g>
                    <rect className="shadow" y="9.6" width="2" height="49.2" />
                  </svg>
                </div>
              );
            } else if (data.length === i + 1) {
              return (
                <div className="end-disk-svg">
                  <svg
                    id="endDiskIconRecom"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 26 68"
                  >
                    <path
                      className="center"
                      d="M-.0251,21.99a4.3433,4.3433,0,0,1,4.04,4.35,4.35,4.35,0,0,1-4.04,4.31Z"
                      transform="translate(0.0251)"
                    />
                    <path
                      id="dd-disk-cost"
                      className={
                        validationIndicator === 1
                          ? valData.validationDataDisks[
                              i - 1
                            ].sim_current_datadisk_cost.toLowerCase()
                          : costResizeIconColor
                      }
                      d="M-.0251,32.93V34h3.89l-.15-.15A3.6,3.6,0,0,0-.0251,32.93Zm0-32.93V6.23a20.006,20.006,0,0,1,15.49,7.62A19.995,19.995,0,0,1,18.2249,34h7.78V0Z"
                      transform="translate(0.0251)"
                    />
                    <g
                      id="dd-disk-health"
                      className={
                        validationIndicator === 1
                          ? valData.validationDataDisks[
                              i - 1
                            ].sim_current_datadisk_health.toLowerCase()
                          : perfResizeIconColor
                      }
                    >
                      <path
                        d="M.7749,35.95a6.2954,6.2954,0,0,0-.8.45V34h3.89c1.18,1.19,2.29,2.47,3.5,3.63,1.53,1.49,3.14,2.89,4.78,4.4l.01-.01a19.8889,19.8889,0,0,0,6.07-8.02h7.78v.02l-.03.01V68h-26V39.67c1.17,2.5,2.32,5.02,3.48,7.54q2.55,5.535,5.1,11.05a4.5984,4.5984,0,0,0,.59.73,10.0421,10.0421,0,0,0,1.09-.54q3.3-2.22,6.57-4.48a2.8406,2.8406,0,0,0,.55-.49.6981.6981,0,0,0,.07-.99.4263.4263,0,0,0-.12-.11c-.66-.61-1.26-1.28-1.89-1.93q-6.87-7.125-13.77-14.25A.9925.9925,0,0,0,.7749,35.95Z"
                        transform="translate(0.0251)"
                      />
                    </g>

                    <rect className="shadow" y="9.6" width="2" height="49.2" />
                  </svg>
                </div>
              );
            }
          });
          resizeIco = (
            <div
              className={
                this.state.fromOverview
                  ? "svgValidationIcoContainer"
                  : "svgGreyIconContainer"
              }
            >
              {diskresizeIco}
            </div>
          );
          if (validationIndicator === 1) {
            resizeIco = data.map((value, i) => {
              if (value.icon === "osdisk") {
                return (
                  <div className="os-disk-svg">
                    <div id={"osdCostTTVal" + tt} className="cost-tooltip-box">
                      {valData.validationOSDisk.sim_rec_os_cost.toLowerCase() ===
                      "good"
                        ? "$"
                        : valData.validationOSDisk.sim_rec_os_cost.toLowerCase() ===
                          "fair"
                        ? "$$"
                        : "$$$"}
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 68">
                      <path
                        id="os-disk-cost"
                        className={valData.validationOSDisk.sim_rec_os_cost.toLowerCase()}
                        d="M26.28,33.05A4.9182,4.9182,0,0,0,24.4,34h6.09l-.15-.15A3.6174,3.6174,0,0,0,26.28,33.05ZM1.72,0C.47,0,0,.47,0,1.7V34H7.76c-.21-.5-.39-1-.56-1.52A20.0882,20.0882,0,1,1,44.85,34h7.18V0Z"
                        transform="translate(0.0016)"
                        onMouseOver={() => {
                          this.showToolTip("osdCostTTVal" + tt);
                        }}
                        onMouseOut={() => {
                          this.hideToolTip("osdCostTTVal" + tt);
                        }}
                      />
                      <g
                        id="os-disk-health"
                        className={valData.validationOSDisk.sim_rec_os_health.toLowerCase()}
                        onMouseOver={() => {
                          this.showToolTip("osdPerfTTVal" + tt);
                        }}
                        onMouseOut={() => {
                          this.hideToolTip("osdPerfTTVal" + tt);
                        }}
                      >
                        <path
                          d="M28.27,36.2a.9925.9925,0,0,0-.87-.25,6.0434,6.0434,0,0,0-1.49.99c-.31.26-.28.63-.09,1.04,1.43,3.06,2.84,6.15,4.26,9.23q2.55,5.535,5.1,11.05a4.5984,4.5984,0,0,0,.59.73,10.0421,10.0421,0,0,0,1.09-.54q3.3-2.22,6.57-4.48a2.8406,2.8406,0,0,0,.55-.49.6981.6981,0,0,0,.07-.99.4263.4263,0,0,0-.12-.11c-.66-.61-1.26-1.28-1.89-1.93Q35.17,43.325,28.27,36.2ZM24.4,34h6.09c1.18,1.19,2.29,2.47,3.5,3.63,1.53,1.49,3.14,2.89,4.78,4.4l.01-.01A19.8889,19.8889,0,0,0,44.85,34h7.18v.02l-.03.01V68s-38.87,0-50.11-.01a2.17,2.17,0,0,1-1.31-.34,2.0005,2.0005,0,0,1-.56-1.34C-.01,58.49,0,34,0,34H7.76a20.0806,20.0806,0,0,0,18.5,12.38,1.6812,1.6812,0,0,0-.09-.32c-1.06-2.28-2.15-4.55-3.14-6.85a4.501,4.501,0,0,1-.38-2.14A4.847,4.847,0,0,1,24.4,34ZM12.16,60.14A4.0552,4.0552,0,0,0,8.19,56H8.11a4.0777,4.0777,0,0,0,0,8.14,4.0417,4.0417,0,0,0,4.04-4.01Z"
                          transform="translate(0.0016)"
                        />
                      </g>
                      <path
                        className="center"
                        d="M26.32,21.98a4.335,4.335,0,1,1-.05,0Z"
                        transform="translate(0.0016)"
                      />
                    </svg>
                    <div
                      id={"osdPerfTTVal" + tt}
                      className={
                        "pref-tooltip-box pref-" +
                        valData.validationOSDisk.sim_rec_os_health.toLowerCase()
                      }
                    ></div>
                  </div>
                );
              } else if (data.length > i + 1) {
                return (
                  <div className="mid-disk-svg">
                    <div
                      id={"dtCostTTVal" + tt + i}
                      className="cost-tooltip-box"
                    >
                      {valData.validationDataDisks[
                        i - 1
                      ].sim_rec_datadisk_cost.toLowerCase() === "good"
                        ? "$"
                        : valData.validationDataDisks[
                            i - 1
                          ].sim_rec_datadisk_cost.toLowerCase() === "fair"
                        ? "$$"
                        : "$$$"}
                    </div>
                    <svg
                      id="diskMidIcon"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 26 68"
                    >
                      <path
                        className="center"
                        d="M-.0251,21.99a4.3433,4.3433,0,0,1,4.04,4.35,4.35,4.35,0,0,1-4.04,4.31Z"
                        transform="translate(0.0251)"
                      />
                      <path
                        id="dd-disk-cost"
                        className={valData.validationDataDisks[
                          i - 1
                        ].sim_rec_datadisk_cost.toLowerCase()}
                        d="M-.0251,32.93V34h3.89l-.15-.15A3.6,3.6,0,0,0-.0251,32.93Zm0-32.93V6.23a20.006,20.006,0,0,1,15.49,7.62A19.995,19.995,0,0,1,18.2249,34h7.78V0Z"
                        transform="translate(0.0251)"
                        onMouseOver={() => {
                          this.showToolTip("dtCostTTVal" + tt + i);
                        }}
                        onMouseOut={() => {
                          this.hideToolTip("dtCostTTVal" + tt + i);
                        }}
                      />
                      <g
                        id="dd-disk-health"
                        className={valData.validationDataDisks[
                          i - 1
                        ].sim_rec_datadisk_health.toLowerCase()}
                        onMouseOver={() => {
                          this.showToolTip("dtPerfTTVal" + tt + i);
                        }}
                        onMouseOut={() => {
                          this.hideToolTip("dtPerfTTVal" + tt + i);
                        }}
                      >
                        <path
                          d="M.7749,35.95a6.2954,6.2954,0,0,0-.8.45V34h3.89c1.18,1.19,2.29,2.47,3.5,3.63,1.53,1.49,3.14,2.89,4.78,4.4l.01-.01a19.8889,19.8889,0,0,0,6.07-8.02h7.78v.02l-.03.01V68h-26V39.67c1.17,2.5,2.32,5.02,3.48,7.54q2.55,5.535,5.1,11.05a4.5984,4.5984,0,0,0,.59.73,10.0421,10.0421,0,0,0,1.09-.54q3.3-2.22,6.57-4.48a2.8406,2.8406,0,0,0,.55-.49.6981.6981,0,0,0,.07-.99.4263.4263,0,0,0-.12-.11c-.66-.61-1.26-1.28-1.89-1.93q-6.87-7.125-13.77-14.25A.9925.9925,0,0,0,.7749,35.95Z"
                          transform="translate(0.0251)"
                        />
                      </g>
                      <rect className="shadow" width="3" height="68" />
                    </svg>
                    <div
                      id={"dtPerfTTVal" + tt + i}
                      className={
                        "pref-tooltip-box pref-" +
                        valData.validationDataDisks[
                          i - 1
                        ].sim_rec_datadisk_health.toLowerCase()
                      }
                    ></div>
                  </div>
                );
              } else if (data.length === i + 1) {
                return (
                  <div className="end-disk-svg">
                    <div
                      id={"dtCostTTVal" + tt + i}
                      className="cost-tooltip-box"
                    >
                      {valData.validationDataDisks[
                        i - 1
                      ].sim_rec_datadisk_cost.toLowerCase() === "good"
                        ? "$"
                        : valData.validationDataDisks[
                            i - 1
                          ].sim_rec_datadisk_cost.toLowerCase() === "fair"
                        ? "$$"
                        : "$$$"}
                    </div>
                    <svg
                      id="diskEndIcon"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 26 68"
                    >
                      <path
                        className="center"
                        d="M-.0251,21.99a4.3433,4.3433,0,0,1,4.04,4.35,4.35,4.35,0,0,1-4.04,4.31Z"
                        transform="translate(0.0251)"
                      />
                      <path
                        id="dd-disk-cost"
                        className={valData.validationDataDisks[
                          i - 1
                        ].sim_rec_datadisk_cost.toLowerCase()}
                        d="M-.0251,32.93V34h3.89l-.15-.15A3.6,3.6,0,0,0-.0251,32.93Zm0-32.93V6.23a20.006,20.006,0,0,1,15.49,7.62A19.995,19.995,0,0,1,18.2249,34h7.78V0Z"
                        transform="translate(0.0251)"
                        onMouseOver={() => {
                          this.showToolTip("dtCostTTVal" + tt + i);
                        }}
                        onMouseOut={() => {
                          this.hideToolTip("dtCostTTVal" + tt + i);
                        }}
                      />
                      <g
                        id="dd-disk-health"
                        className={valData.validationDataDisks[
                          i - 1
                        ].sim_rec_datadisk_health.toLowerCase()}
                        onMouseOver={() => {
                          this.showToolTip("dtPerfTTVal" + tt + i);
                        }}
                        onMouseOut={() => {
                          this.hideToolTip("dtPerfTTVal" + tt + i);
                        }}
                      >
                        <path
                          d="M.7749,35.95a6.2954,6.2954,0,0,0-.8.45V34h3.89c1.18,1.19,2.29,2.47,3.5,3.63,1.53,1.49,3.14,2.89,4.78,4.4l.01-.01a19.8889,19.8889,0,0,0,6.07-8.02h7.78v.02l-.03.01V68h-26V39.67c1.17,2.5,2.32,5.02,3.48,7.54q2.55,5.535,5.1,11.05a4.5984,4.5984,0,0,0,.59.73,10.0421,10.0421,0,0,0,1.09-.54q3.3-2.22,6.57-4.48a2.8406,2.8406,0,0,0,.55-.49.6981.6981,0,0,0,.07-.99.4263.4263,0,0,0-.12-.11c-.66-.61-1.26-1.28-1.89-1.93q-6.87-7.125-13.77-14.25A.9925.9925,0,0,0,.7749,35.95Z"
                          transform="translate(0.0251)"
                        />
                      </g>
                      <rect className="shadow" width="3" height="68" />
                    </svg>
                    <div
                      id={"dtPerfTTVal" + tt + i}
                      className={
                        "pref-tooltip-box pref-" +
                        valData.validationDataDisks[
                          i - 1
                        ].sim_rec_datadisk_health.toLowerCase()
                      }
                    ></div>
                  </div>
                );
              }
            });
          }
        }
        if (this.props.isIcon === true) {
          let resizeDiskStatusIcon = data.map((value, i) => {
            let curStatus =
              validationIndicator === 2 || value.status === null
                ? "pending"
                : value.status.toLowerCase();
            if (value.icon === "osdisk") {
              return this.state.entityType === "db" ? (
                <div className="state-icon-resize">
                  <div
                    className={"state-icon " + curStatus}
                    title={curStatus.toUpperCase()}
                  ></div>
                </div>
              ) : (
                <div className="os-disk-state-icon-cont">
                  <div
                    className={"state-icon " + curStatus}
                    title={curStatus.toUpperCase()}
                  ></div>
                </div>
              );
            } else if (data.length > i + 1) {
              return (
                <div className="data-disk-state-icon-cont">
                  <div
                    className={"state-icon " + curStatus}
                    title={curStatus.toUpperCase()}
                  ></div>
                </div>
              );
            } else if (data.length === i + 1) {
              return (
                <div className="data-disk-state-icon-cont">
                  <div
                    className={"state-icon " + curStatus}
                    title={curStatus.toUpperCase()}
                  ></div>
                </div>
              );
            }
          });
          resizeStatusIcon = (
            <div className="state-container-resize">
              <div
                className={
                  this.state.entityType === "db"
                    ? ""
                    : " disk-state-icon-resize"
                }
              >
                {resizeDiskStatusIcon}
              </div>
            </div>
          );
          if (validationIndicator === 1) {
            resizeStatusIcon = (
              <div class="disk-state-container">
                <div class="disk-state-name1">Current</div>
                <div class="disk-space-filler"></div>
                <div class="disk-state-name2">{this.props.valObjective}</div>
              </div>
            );
            let valDiskCostUtil = data.map((value, i) => {
              if (value.icon === "osdisk") {
                valUtil =
                  valData.validationOSDisk.sim_osdisk_utils_result === "N/A"
                    ? "na"
                    : valData.validationOSDisk.sim_osdisk_utils_result === "*"
                    ? "star"
                    : valData.validationVM.sim_osdisk_utils_result === null
                    ? "skip"
                    : valData.validationOSDisk.sim_osdisk_utils_result.toLowerCase();
                return (
                  <div class="disk-icon-cont">
                    <div
                      class={"disk-cost-small-icon " + valUtil + "-tick"}
                    ></div>
                    <div class="disk-number">OS</div>
                  </div>
                );
              } else if (data.length > i + 1) {
                valUtil =
                  valData.validationDataDisks[i - 1]
                    .sim_datadisk_utils_result === "N/A"
                    ? "na"
                    : valData.validationDataDisks[i - 1]
                        .sim_datadisk_utils_result === "*"
                    ? "star"
                    : valData.validationDataDisks[i - 1]
                        .sim_network_utils_result === null
                    ? "skip"
                    : valData.validationDataDisks[
                        i - 1
                      ].sim_datadisk_utils_result.toLowerCase();
                return (
                  <div class="disk-icon-cont">
                    <div
                      class={"disk-cost-small-icon " + valUtil + "-tick"}
                    ></div>
                    <div class="disk-number">{i - 1}</div>
                  </div>
                );
              } else if (data.length === i + 1) {
                valUtil =
                  valData.validationDataDisks[i - 1]
                    .sim_datadisk_utils_result === "N/A"
                    ? "na"
                    : valData.validationDataDisks[i - 1]
                        .sim_datadisk_utils_result === "*"
                    ? "star"
                    : valData.validationDataDisks[i - 1]
                        .sim_network_utils_result === null
                    ? "skip"
                    : valData.validationDataDisks[
                        i - 1
                      ].sim_datadisk_utils_result.toLowerCase();
                return (
                  <div class="disk-icon-cont">
                    <div
                      class={"disk-cost-small-icon " + valUtil + "-tick"}
                    ></div>
                    <div class="disk-number">{i - 1}</div>
                  </div>
                );
              }
            });
            let valDiskHealthUtil = data.map((value, i) => {
              if (value.icon === "osdisk") {
                valHealth =
                  valData.validationOSDisk.sim_osdisk_health_result === "N/A"
                    ? "na"
                    : valData.validationOSDisk.sim_osdisk_health_result === "*"
                    ? "star"
                    : valData.validationOSDisk.sim_osdisk_health_result === null
                    ? "skip"
                    : valData.validationOSDisk.sim_osdisk_health_result.toLowerCase();
                return (
                  <div className="disk-icon-cont">
                    <div class="disk-number">OS</div>
                    <div
                      className={"disk-pref-small-icon " + valHealth + "-tick"}
                    ></div>
                  </div>
                );
              } else if (data.length > i + 1) {
                valHealth =
                  valData.validationDataDisks[i - 1]
                    .sim_datadisk_health_result === "N/A"
                    ? "na"
                    : valData.validationDataDisks[i - 1]
                        .sim_network_health_result === "*"
                    ? "star"
                    : valData.validationDataDisks[i - 1]
                        .sim_datadisk_health_result === null
                    ? "skip"
                    : valData.validationDataDisks[
                        i - 1
                      ].sim_datadisk_health_result.toLowerCase();
                return (
                  <div className="disk-icon-cont">
                    <div class="disk-number">{i - 1}</div>
                    <div
                      class={"disk-pref-small-icon " + valHealth + "-tick"}
                    ></div>
                  </div>
                );
              } else if (data.length === i + 1) {
                valHealth =
                  valData.validationDataDisks[i - 1]
                    .sim_datadisk_health_result === "N/A"
                    ? "na"
                    : valData.validationDataDisks[i - 1]
                        .sim_network_health_result === "*"
                    ? "star"
                    : valData.validationDataDisks[i - 1]
                        .sim_datadisk_health_result === null
                    ? "skip"
                    : valData.validationDataDisks[
                        i - 1
                      ].sim_datadisk_health_result.toLowerCase();
                return (
                  <div className="disk-icon-cont">
                    <div class="disk-number">{i - 1}</div>
                    <div
                      className={"disk-pref-small-icon " + valHealth + "-tick"}
                    ></div>
                  </div>
                );
              }
            });
            rightArrow = (
              <div class="disk-small-icon-container">
                <div class="icon-number-cont">{valDiskCostUtil}</div>
                <div class="right-arrow-cont">
                  <div class="disk-arrow-right" />
                </div>
                <div class="icon-number-cont">{valDiskHealthUtil}</div>
              </div>
            );
          }
        }
    }

    return (
      <div className="icon-wrapper">
        {this.props.isIcon === true ? resizeStatusIcon : null}
        <div className="marker-icon-container" style={{ gap: "7px" }}>
          {showCostPerfMarker === true ? costPerfMarker : null}
          <div class="icon-container">
            {ico}{" "}
            {this.props.isResize === true || validationIndicator === 1
              ? rightArrow
              : null}
            {!this.props.isResizeFirstPage && this.props.isResize === true
              ? resizeIco
              : null}
          </div>
          {this.props.isLine === true ? lineSeparator : null}
        </div>
        {this.props.isResizeFirstPage ? (
          <div class="icon-container">
            {this.props.isResize === true ? resizeIco : null}
          </div>
        ) : null}
      </div>
    );
  }
}
export default SvgColorOverview;
